var _filter, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _clipPath16, _clipPath17, _clipPath18, _clipPath19, _clipPath20, _clipPath21, _clipPath22, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "400px",
    height: "400px",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    fill: "#050505"
  }, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    style: {
      fill: "#262626",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#262626",
      fillOpacity: 1
    },
    d: "M 267.789062 272.097656 L 138.652344 258.792969 C 134.703125 258.386719 131.832031 254.855469 132.238281 250.90625 L 154.601562 33.800781 C 155.179688 28.191406 160.199219 24.109375 165.808594 24.6875 L 288.929688 37.371094 C 294.542969 37.949219 298.621094 42.964844 298.042969 48.578125 L 275.675781 265.683594 C 275.273438 269.632812 271.738281 272.503906 267.789062 272.097656 Z M 267.789062 272.097656 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    style: {
      fill: "#262626",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#262626",
      fillOpacity: 1
    },
    d: "M 186.886719 233.035156 L 142.359375 228.449219 C 141.296875 228.339844 140.523438 227.386719 140.632812 226.324219 L 142.4375 208.800781 C 142.546875 207.738281 143.496094 206.964844 144.5625 207.074219 L 189.089844 211.664062 C 190.152344 211.773438 190.925781 212.722656 190.816406 213.785156 L 189.011719 231.308594 C 188.902344 232.371094 187.953125 233.144531 186.886719 233.035156 Z M 186.886719 233.035156 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    style: {
      fill: "#262626",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface11",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#262626",
      fillOpacity: 1
    },
    d: "M 167.53125 138.429688 L 150 136.625 C 149.085938 136.53125 148.417969 135.710938 148.511719 134.796875 L 150.320312 117.265625 C 150.414062 116.351562 151.230469 115.6875 152.148438 115.777344 L 169.679688 117.585938 C 170.59375 117.679688 171.257812 118.496094 171.164062 119.414062 L 169.359375 136.945312 C 169.265625 137.859375 168.445312 138.523438 167.53125 138.429688 Z M 167.53125 138.429688 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    style: {
      fill: "#262626",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface14",
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#262626",
      fillOpacity: 1
    },
    d: "M 196.597656 141.425781 L 179.066406 139.617188 C 178.152344 139.523438 177.488281 138.707031 177.582031 137.792969 L 179.386719 120.261719 C 179.480469 119.34375 180.300781 118.679688 181.214844 118.773438 L 198.746094 120.578125 C 199.660156 120.675781 200.324219 121.492188 200.230469 122.40625 L 198.425781 139.9375 C 198.332031 140.855469 197.511719 141.519531 196.597656 141.425781 Z M 196.597656 141.425781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    style: {
      fill: "#262626",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface17",
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#262626",
      fillOpacity: 1
    },
    d: "M 226.730469 144.527344 L 209.199219 142.722656 C 208.285156 142.628906 207.621094 141.808594 207.714844 140.894531 L 209.519531 123.363281 C 209.613281 122.449219 210.433594 121.785156 211.347656 121.878906 L 228.878906 123.683594 C 229.792969 123.777344 230.457031 124.597656 230.363281 125.511719 L 228.558594 143.042969 C 228.464844 143.957031 227.644531 144.625 226.730469 144.527344 Z M 226.730469 144.527344 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    style: {
      fill: "#262626",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface20",
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#262626",
      fillOpacity: 1
    },
    d: "M 256.863281 147.632812 L 239.332031 145.828125 C 238.417969 145.734375 237.753906 144.914062 237.847656 144 L 239.652344 126.46875 C 239.746094 125.554688 240.5625 124.890625 241.480469 124.984375 L 259.011719 126.789062 C 259.925781 126.882812 260.589844 127.703125 260.496094 128.617188 L 258.691406 146.148438 C 258.597656 147.0625 257.777344 147.726562 256.863281 147.632812 Z M 256.863281 147.632812 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    style: {
      fill: "#262626",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface23",
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#262626",
      fillOpacity: 1
    },
    d: "M 164.386719 168.964844 L 146.855469 167.160156 C 145.9375 167.066406 145.273438 166.246094 145.367188 165.332031 L 147.175781 147.800781 C 147.269531 146.886719 148.085938 146.222656 149 146.316406 L 166.53125 148.121094 C 167.449219 148.21875 168.113281 149.035156 168.019531 149.949219 L 166.210938 167.480469 C 166.117188 168.394531 165.300781 169.058594 164.386719 168.964844 Z M 164.386719 168.964844 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    style: {
      fill: "#262626",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface26",
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#262626",
      fillOpacity: 1
    },
    d: "M 193.453125 171.960938 L 175.921875 170.152344 C 175.003906 170.058594 174.339844 169.242188 174.433594 168.328125 L 176.242188 150.796875 C 176.335938 149.878906 177.152344 149.214844 178.066406 149.308594 L 195.597656 151.113281 C 196.515625 151.210938 197.179688 152.027344 197.085938 152.941406 L 195.277344 170.472656 C 195.183594 171.390625 194.367188 172.054688 193.453125 171.960938 Z M 193.453125 171.960938 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    style: {
      fill: "#262626",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface29",
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#262626",
      fillOpacity: 1
    },
    d: "M 223.585938 175.066406 L 206.054688 173.257812 C 205.136719 173.164062 204.472656 172.347656 204.566406 171.429688 L 206.375 153.898438 C 206.46875 152.984375 207.285156 152.320312 208.203125 152.414062 L 225.734375 154.222656 C 226.648438 154.316406 227.3125 155.132812 227.21875 156.046875 L 225.410156 173.578125 C 225.316406 174.492188 224.5 175.160156 223.585938 175.066406 Z M 223.585938 175.066406 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    style: {
      fill: "#262626",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface32",
    clipPath: "url(#clip10)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#262626",
      fillOpacity: 1
    },
    d: "M 253.71875 178.167969 L 236.1875 176.363281 C 235.269531 176.269531 234.605469 175.449219 234.699219 174.535156 L 236.507812 157.003906 C 236.601562 156.089844 237.417969 155.425781 238.335938 155.519531 L 255.867188 157.324219 C 256.78125 157.417969 257.445312 158.238281 257.351562 159.152344 L 255.542969 176.683594 C 255.449219 177.597656 254.632812 178.261719 253.71875 178.167969 Z M 253.71875 178.167969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    style: {
      fill: "#262626",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface35",
    clipPath: "url(#clip11)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#262626",
      fillOpacity: 1
    },
    d: "M 161.265625 199.253906 L 143.734375 197.445312 C 142.820312 197.351562 142.152344 196.535156 142.246094 195.621094 L 144.054688 178.089844 C 144.148438 177.171875 144.964844 176.507812 145.882812 176.601562 L 163.414062 178.40625 C 164.328125 178.503906 164.992188 179.320312 164.898438 180.234375 L 163.09375 197.765625 C 162.996094 198.679688 162.179688 199.347656 161.265625 199.253906 Z M 161.265625 199.253906 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    style: {
      fill: "#262626",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface38",
    clipPath: "url(#clip12)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#262626",
      fillOpacity: 1
    },
    d: "M 190.332031 202.246094 L 172.800781 200.441406 C 171.886719 200.347656 171.21875 199.527344 171.3125 198.613281 L 173.121094 181.082031 C 173.214844 180.167969 174.03125 179.503906 174.949219 179.597656 L 192.480469 181.402344 C 193.394531 181.496094 194.058594 182.316406 193.964844 183.230469 L 192.160156 200.761719 C 192.066406 201.675781 191.246094 202.339844 190.332031 202.246094 Z M 190.332031 202.246094 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    style: {
      fill: "#262626",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface41",
    clipPath: "url(#clip13)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#262626",
      fillOpacity: 1
    },
    d: "M 220.464844 205.351562 L 202.933594 203.542969 C 202.019531 203.449219 201.355469 202.632812 201.445312 201.71875 L 203.253906 184.1875 C 203.347656 183.269531 204.164062 182.605469 205.082031 182.699219 L 222.613281 184.507812 C 223.527344 184.601562 224.191406 185.417969 224.097656 186.335938 L 222.292969 203.867188 C 222.199219 204.78125 221.378906 205.445312 220.464844 205.351562 Z M 220.464844 205.351562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    style: {
      fill: "#262626",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface44",
    clipPath: "url(#clip14)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#262626",
      fillOpacity: 1
    },
    d: "M 250.597656 208.457031 L 233.066406 206.648438 C 232.152344 206.554688 231.488281 205.738281 231.578125 204.824219 L 233.386719 187.292969 C 233.480469 186.375 234.296875 185.710938 235.214844 185.804688 L 252.746094 187.613281 C 253.660156 187.707031 254.324219 188.523438 254.230469 189.4375 L 252.425781 206.96875 C 252.332031 207.886719 251.511719 208.550781 250.597656 208.457031 Z M 250.597656 208.457031 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    style: {
      fill: "#262626",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface47",
    clipPath: "url(#clip15)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#262626",
      fillOpacity: 1
    },
    d: "M 217.316406 235.902344 L 199.785156 234.097656 C 198.871094 234.003906 198.207031 233.183594 198.300781 232.269531 L 200.105469 214.738281 C 200.199219 213.824219 201.019531 213.160156 201.933594 213.253906 L 219.464844 215.058594 C 220.378906 215.152344 221.042969 215.972656 220.949219 216.886719 L 219.144531 234.417969 C 219.050781 235.332031 218.230469 235.996094 217.316406 235.902344 Z M 217.316406 235.902344 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    style: {
      fill: "#262626",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface50",
    clipPath: "url(#clip16)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#262626",
      fillOpacity: 1
    },
    d: "M 247.449219 239.007812 L 229.917969 237.199219 C 229.003906 237.105469 228.339844 236.289062 228.433594 235.375 L 230.238281 217.84375 C 230.335938 216.925781 231.152344 216.261719 232.066406 216.355469 L 249.597656 218.164062 C 250.511719 218.257812 251.179688 219.074219 251.085938 219.992188 L 249.277344 237.523438 C 249.183594 238.4375 248.363281 239.101562 247.449219 239.007812 Z M 247.449219 239.007812 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    style: {
      fill: "#262626",
      fillOpacity: 0.6,
      stroke: "none"
    }
  }))), _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface53",
    clipPath: "url(#clip17)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 109.410156 377.34375 L 125.941406 378.851562 L 126.210938 377.472656 L 109.890625 375.398438 L 109.429688 377.15625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    style: {
      fill: "#262626",
      fillOpacity: 0.6,
      stroke: "none"
    }
  }))), _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface56",
    clipPath: "url(#clip18)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 172.847656 369.6875 C 172.285156 369.824219 171.882812 370.4375 171.996094 371.003906 C 172.105469 371.570312 172.726562 371.988281 173.292969 371.863281 C 173.855469 371.738281 174.363281 371.011719 174.1875 370.464844 C 174.011719 369.914062 173.257812 369.464844 172.738281 369.722656 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    style: {
      fill: "#262626",
      fillOpacity: 0.6,
      stroke: "none"
    }
  }))), _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface59",
    clipPath: "url(#clip19)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 167.734375 379.058594 L 167.886719 376.730469 L 195.613281 377.496094 C 195.613281 377.496094 196.535156 377.894531 196.683594 379.058594 Z M 167.734375 379.058594 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    style: {
      fill: "#262626",
      fillOpacity: 0.301961,
      stroke: "none"
    }
  }))), _clipPath20 || (_clipPath20 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface62",
    clipPath: "url(#clip20)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#262626",
      fillOpacity: 1
    },
    d: "M 182.496094 359.328125 L 182.324219 361.96875 L 168.179688 361.410156 L 168.234375 359.027344 Z M 182.496094 359.328125 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    style: {
      fill: "#262626",
      fillOpacity: 0.301961,
      stroke: "none"
    }
  }))), _clipPath21 || (_clipPath21 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface65",
    clipPath: "url(#clip21)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#262626",
      fillOpacity: 1
    },
    d: "M 173.0625 147.804688 C 176.445312 158.433594 179.058594 169.59375 182.441406 180.226562 L 181.632812 158.203125 C 178.496094 155.308594 175.644531 151.835938 173.0625 147.804688 Z M 173.0625 147.804688 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    style: {
      fill: "#262626",
      fillOpacity: 0.2,
      stroke: "none"
    }
  }))), _clipPath22 || (_clipPath22 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22",
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface68",
    clipPath: "url(#clip22)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#262626",
      fillOpacity: 1
    },
    d: "M 307.953125 256.699219 C 306.839844 258.710938 305.726562 260.726562 304.613281 262.742188 C 304.535156 262.882812 304.433594 263.042969 304.273438 263.054688 C 304.097656 263.070312 303.964844 262.902344 303.871094 262.757812 C 300.929688 258.242188 297.988281 253.726562 295.042969 249.210938 L 297.078125 248.058594 Z M 307.953125 256.699219 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(87.843137%,87.843137%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 287.882812 199.113281 C 287.882812 199.113281 287.238281 199.664062 285.816406 200.175781 C 284.421875 200.675781 282.109375 201.039062 279.527344 200.097656 C 278.257812 199.625 276.933594 198.839844 275.847656 197.65625 C 274.773438 196.472656 273.863281 194.941406 273.5 193.160156 C 273.296875 192.277344 273.234375 191.34375 273.3125 190.398438 C 273.375 189.453125 273.589844 188.496094 273.960938 187.582031 C 274.667969 185.738281 276.035156 184.089844 277.800781 182.964844 C 279.585938 181.871094 281.667969 181.367188 283.632812 181.542969 C 284.617188 181.609375 285.574219 181.835938 286.449219 182.195312 C 287.332031 182.542969 288.144531 183.007812 288.847656 183.578125 C 290.289062 184.6875 291.265625 186.175781 291.855469 187.660156 C 292.445312 189.15625 292.566406 190.6875 292.433594 192.035156 C 292.148438 194.769531 290.804688 196.6875 289.746094 197.722656 C 288.660156 198.777344 287.882812 199.113281 287.882812 199.113281 C 287.84375 199.058594 288.582031 198.652344 289.59375 197.578125 C 290.589844 196.523438 291.832031 194.632812 292.058594 192.003906 C 292.160156 190.707031 292.023438 189.246094 291.441406 187.824219 C 290.859375 186.417969 289.917969 185.007812 288.542969 183.972656 C 287.875 183.433594 287.097656 183 286.261719 182.675781 C 285.429688 182.339844 284.527344 182.128906 283.59375 182.070312 C 281.734375 181.910156 279.773438 182.390625 278.085938 183.425781 C 276.417969 184.488281 275.125 186.039062 274.453125 187.777344 C 274.097656 188.640625 273.890625 189.546875 273.824219 190.441406 C 273.75 191.332031 273.800781 192.222656 273.988281 193.058594 C 274.316406 194.75 275.167969 196.210938 276.175781 197.355469 C 277.199219 198.5 278.449219 199.265625 279.660156 199.742188 C 282.121094 200.695312 284.367188 200.40625 285.753906 199.980469 C 287.160156 199.539062 287.851562 199.054688 287.882812 199.113281 Z M 287.882812 199.113281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(87.843137%,87.843137%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 289.578125 211.546875 C 289.582031 211.542969 289.664062 211.613281 289.824219 211.769531 C 290.003906 211.941406 290.238281 212.167969 290.542969 212.464844 C 291.199219 213.109375 292.140625 214.035156 293.363281 215.242188 L 293.253906 215.230469 C 295.148438 214.03125 297.636719 212.457031 300.648438 210.554688 L 300.589844 210.714844 C 300.058594 209.207031 299.464844 207.527344 298.832031 205.734375 L 298.800781 205.644531 L 298.867188 205.574219 C 300.078125 204.269531 301.207031 202.726562 302.136719 200.957031 L 302.1875 200.863281 L 302.292969 200.863281 C 303.941406 200.863281 305.726562 200.867188 307.582031 200.871094 L 307.394531 201.019531 C 308.007812 198.335938 308.660156 195.484375 309.34375 192.492188 L 309.460938 192.730469 C 307.984375 192.023438 306.359375 191.242188 304.695312 190.441406 L 304.574219 190.382812 L 304.570312 190.246094 C 304.511719 188.492188 304.21875 186.570312 303.632812 184.683594 L 303.589844 184.550781 L 303.691406 184.453125 C 304.851562 183.296875 306.132812 182.023438 307.4375 180.726562 L 307.40625 181.023438 C 305.945312 178.695312 304.375 176.183594 302.761719 173.609375 L 303.058594 173.714844 C 301.503906 174.257812 299.800781 174.851562 298.070312 175.457031 L 297.925781 175.507812 L 297.8125 175.402344 C 296.523438 174.195312 294.953125 173.042969 293.222656 172.132812 L 293.082031 172.0625 L 293.085938 171.902344 C 293.089844 170.246094 293.097656 168.441406 293.105469 166.613281 L 293.308594 166.875 C 290.609375 166.25 287.71875 165.582031 284.785156 164.90625 L 285.085938 164.761719 C 284.359375 166.265625 283.578125 167.890625 282.789062 169.523438 L 282.71875 169.671875 L 282.554688 169.675781 C 280.765625 169.730469 278.851562 170.027344 277.003906 170.597656 L 277 170.601562 C 276.878906 170.570312 277.269531 170.667969 276.730469 170.53125 L 276.703125 170.503906 L 276.671875 170.476562 L 276.613281 170.417969 L 276.496094 170.296875 L 276.261719 170.0625 L 275.796875 169.589844 L 274.863281 168.648438 C 274.242188 168.023438 273.625 167.398438 273.007812 166.777344 L 273.339844 166.816406 C 270.832031 168.378906 268.359375 169.925781 265.921875 171.445312 L 266.03125 171.132812 C 266.613281 172.8125 267.195312 174.476562 267.769531 176.125 L 267.820312 176.273438 L 267.710938 176.390625 C 266.40625 177.78125 265.308594 179.332031 264.4375 180.976562 L 264.363281 181.113281 L 264.203125 181.113281 C 262.417969 181.105469 260.65625 181.097656 258.917969 181.085938 L 259.167969 180.890625 C 258.492188 183.796875 257.832031 186.636719 257.191406 189.40625 L 257.058594 189.128906 C 258.671875 189.910156 260.257812 190.679688 261.8125 191.433594 L 261.945312 191.5 L 261.953125 191.644531 C 262.007812 193.570312 262.328125 195.445312 262.867188 197.207031 L 262.910156 197.34375 L 262.808594 197.441406 C 261.523438 198.71875 260.269531 199.953125 259.050781 201.15625 L 259.082031 200.878906 C 260.707031 203.492188 262.238281 205.960938 263.699219 208.308594 L 263.457031 208.222656 C 265.214844 207.617188 266.863281 207.046875 268.453125 206.496094 L 268.5625 206.457031 L 268.648438 206.539062 C 270.117188 207.921875 271.667969 208.996094 273.242188 209.832031 L 273.335938 209.882812 L 273.335938 209.992188 C 273.320312 211.910156 273.304688 213.640625 273.292969 215.277344 L 273.171875 215.121094 C 276.46875 215.898438 279.277344 216.5625 281.683594 217.128906 L 281.546875 217.195312 C 282.480469 215.300781 283.242188 213.742188 283.878906 212.449219 L 283.902344 212.402344 L 283.953125 212.398438 C 285.875 212.347656 287.285156 212.078125 288.207031 211.875 C 288.648438 211.769531 288.988281 211.6875 289.238281 211.628906 C 289.472656 211.566406 289.582031 211.542969 289.578125 211.546875 C 289.578125 211.554688 289.464844 211.597656 289.25 211.671875 C 289.027344 211.742188 288.6875 211.847656 288.226562 211.964844 C 287.304688 212.191406 285.894531 212.492188 283.960938 212.574219 L 284.035156 212.523438 C 283.414062 213.828125 282.671875 215.390625 281.765625 217.300781 L 281.722656 217.386719 L 281.628906 217.363281 C 279.21875 216.816406 276.402344 216.179688 273.097656 215.429688 L 272.976562 215.402344 L 272.976562 215.273438 C 272.976562 213.640625 272.980469 211.910156 272.980469 209.988281 L 273.074219 210.144531 C 271.472656 209.300781 269.886719 208.21875 268.382812 206.816406 L 268.578125 206.859375 C 266.992188 207.417969 265.347656 207.996094 263.59375 208.609375 L 263.4375 208.664062 L 263.347656 208.523438 C 261.878906 206.183594 260.335938 203.722656 258.703125 201.113281 L 258.609375 200.960938 L 258.734375 200.835938 C 259.953125 199.625 261.195312 198.386719 262.480469 197.109375 L 262.421875 197.34375 C 261.867188 195.542969 261.535156 193.625 261.46875 191.65625 L 261.605469 191.867188 C 260.042969 191.113281 258.457031 190.351562 256.839844 189.570312 L 256.664062 189.488281 L 256.707031 189.292969 C 257.347656 186.523438 258 183.679688 258.671875 180.769531 L 258.714844 180.570312 L 258.921875 180.570312 C 260.660156 180.578125 262.421875 180.582031 264.207031 180.589844 L 263.976562 180.726562 C 264.867188 179.042969 265.992188 177.453125 267.328125 176.027344 L 267.269531 176.292969 C 266.695312 174.648438 266.117188 172.984375 265.527344 171.304688 L 265.457031 171.105469 L 265.640625 170.992188 C 268.078125 169.46875 270.550781 167.921875 273.058594 166.355469 L 273.242188 166.242188 L 273.390625 166.394531 C 274.007812 167.015625 274.625 167.640625 275.246094 168.265625 L 276.179688 169.207031 L 276.648438 169.679688 L 276.882812 169.914062 L 277 170.035156 L 277.058594 170.09375 L 277.089844 170.121094 L 277.101562 170.136719 L 277.113281 170.148438 C 276.574219 170.011719 276.964844 170.109375 276.84375 170.078125 L 276.847656 170.078125 C 278.742188 169.492188 280.703125 169.1875 282.535156 169.132812 L 282.304688 169.28125 C 283.09375 167.648438 283.878906 166.027344 284.605469 164.523438 L 284.699219 164.328125 L 284.90625 164.378906 C 287.835938 165.058594 290.730469 165.726562 293.425781 166.351562 L 293.632812 166.402344 L 293.632812 166.609375 C 293.621094 168.4375 293.613281 170.242188 293.605469 171.898438 L 293.464844 171.667969 C 295.238281 172.601562 296.84375 173.78125 298.160156 175.023438 L 297.902344 174.96875 C 299.632812 174.367188 301.339844 173.773438 302.894531 173.234375 L 303.082031 173.167969 L 303.1875 173.335938 C 304.792969 175.914062 306.359375 178.429688 307.8125 180.761719 L 307.914062 180.925781 L 307.777344 181.0625 C 306.46875 182.355469 305.183594 183.625 304.019531 184.773438 L 304.078125 184.542969 C 304.671875 186.472656 304.960938 188.4375 305.011719 190.230469 L 304.886719 190.035156 C 306.550781 190.84375 308.171875 191.628906 309.644531 192.34375 L 309.796875 192.421875 L 309.757812 192.585938 C 309.058594 195.574219 308.394531 198.417969 307.769531 201.101562 L 307.734375 201.25 L 307.578125 201.25 C 305.726562 201.238281 303.941406 201.222656 302.292969 201.210938 L 302.449219 201.117188 C 301.492188 202.914062 300.335938 204.472656 299.097656 205.785156 L 299.128906 205.625 C 299.75 207.425781 300.328125 209.109375 300.847656 210.621094 L 300.886719 210.726562 L 300.792969 210.78125 C 297.757812 212.652344 295.253906 214.199219 293.34375 215.371094 L 293.285156 215.410156 L 293.238281 215.359375 C 292.054688 214.136719 291.144531 213.199219 290.511719 212.542969 C 290.214844 212.230469 289.984375 211.988281 289.8125 211.808594 C 289.65625 211.644531 289.578125 211.554688 289.578125 211.546875 Z M 289.578125 211.546875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(87.843137%,87.843137%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 306.996094 148.257812 C 304.386719 149.0625 301.710938 149.5 299.042969 149.585938 L 295.792969 156.316406 L 283.742188 153.527344 L 283.777344 146.050781 C 281.417969 144.804688 279.203125 143.238281 277.210938 141.371094 L 270.15625 143.828125 L 263.605469 133.335938 L 268.914062 128.078125 C 268.109375 125.464844 267.675781 122.789062 267.589844 120.125 L 260.859375 116.871094 L 263.644531 104.824219 L 271.121094 104.855469 C 272.367188 102.496094 273.933594 100.285156 275.804688 98.292969 L 273.34375 91.238281 L 283.835938 84.6875 L 289.097656 89.992188 C 291.707031 89.1875 294.382812 88.753906 297.050781 88.667969 L 300.300781 81.9375 L 312.351562 84.726562 L 312.316406 92.203125 C 314.675781 93.449219 316.886719 95.015625 318.882812 96.882812 L 325.9375 94.425781 L 332.488281 104.917969 L 327.179688 110.175781 C 327.984375 112.785156 328.421875 115.460938 328.503906 118.128906 L 335.234375 121.382812 L 332.449219 133.429688 L 324.972656 133.398438 C 323.726562 135.757812 322.160156 137.96875 320.289062 139.960938 L 322.75 147.015625 L 312.257812 153.566406 Z M 304.597656 130.675781 C 310.8125 126.796875 312.707031 118.613281 308.824219 112.398438 C 304.945312 106.179688 296.757812 104.289062 290.542969 108.167969 C 284.328125 112.050781 282.433594 120.234375 286.316406 126.449219 C 290.195312 132.664062 298.378906 134.558594 304.597656 130.675781 Z M 304.597656 130.675781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(92.156863%,92.156863%,92.156863%)",
      fillOpacity: 1
    },
    d: "M 335.386719 188.109375 C 333.996094 188.539062 332.574219 188.769531 331.15625 188.816406 L 329.425781 192.394531 L 323.015625 190.914062 L 323.03125 186.9375 C 321.777344 186.273438 320.601562 185.4375 319.539062 184.445312 L 315.785156 185.753906 L 312.300781 180.171875 L 315.125 177.371094 C 314.695312 175.984375 314.464844 174.5625 314.421875 173.140625 L 310.839844 171.410156 L 312.320312 165 L 316.296875 165.019531 C 316.960938 163.765625 317.796875 162.589844 318.789062 161.527344 L 317.480469 157.773438 L 323.0625 154.289062 L 325.863281 157.113281 C 327.25 156.683594 328.671875 156.453125 330.09375 156.40625 L 331.824219 152.828125 L 338.234375 154.308594 L 338.214844 158.289062 C 339.46875 158.953125 340.644531 159.785156 341.707031 160.777344 L 345.460938 159.46875 L 348.945312 165.050781 L 346.121094 167.847656 C 346.550781 169.238281 346.78125 170.664062 346.828125 172.082031 L 350.40625 173.8125 L 348.925781 180.222656 L 344.949219 180.203125 C 344.285156 181.460938 343.453125 182.636719 342.457031 183.695312 L 343.765625 187.449219 L 338.183594 190.933594 Z M 334.109375 178.757812 C 337.414062 176.691406 338.421875 172.339844 336.359375 169.03125 C 334.292969 165.726562 329.9375 164.71875 326.632812 166.78125 C 323.324219 168.847656 322.320312 173.199219 324.382812 176.507812 C 326.445312 179.8125 330.800781 180.820312 334.109375 178.757812 Z M 334.109375 178.757812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(87.843137%,87.843137%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 89.890625 117.320312 C 89.972656 117.402344 86.222656 121.246094 81.511719 125.902344 C 76.804688 130.5625 72.921875 134.273438 72.84375 134.191406 C 72.761719 134.109375 76.511719 130.265625 81.222656 125.605469 C 85.929688 120.949219 89.808594 117.238281 89.890625 117.320312 Z M 89.890625 117.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(87.843137%,87.843137%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 89.933594 134.148438 C 89.851562 134.230469 85.953125 130.539062 81.222656 125.90625 C 76.492188 121.269531 72.722656 117.445312 72.800781 117.363281 C 72.882812 117.28125 76.78125 120.972656 81.511719 125.605469 C 86.242188 130.242188 90.011719 134.066406 89.933594 134.148438 Z M 89.933594 134.148438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(87.843137%,87.843137%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 106.855469 223.789062 C 106.84375 223.902344 102.058594 223.492188 96.167969 222.871094 C 90.273438 222.25 85.507812 221.652344 85.519531 221.535156 C 85.53125 221.421875 90.316406 221.832031 96.210938 222.457031 C 102.101562 223.078125 106.867188 223.675781 106.855469 223.789062 Z M 106.855469 223.789062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(87.843137%,87.843137%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 106.007812 231.824219 C 105.996094 231.9375 101.210938 231.527344 95.320312 230.90625 C 89.425781 230.285156 84.660156 229.6875 84.671875 229.574219 C 84.683594 229.457031 89.46875 229.871094 95.363281 230.492188 C 101.253906 231.113281 106.019531 231.710938 106.007812 231.824219 Z M 106.007812 231.824219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.156863%,92.156863%,92.156863%)",
      fillOpacity: 1
    },
    d: "M 48.320312 206.152344 C 48.320312 206.152344 41.984375 205.699219 42.566406 219.910156 C 43.152344 234.121094 44.601562 241.691406 44.601562 241.691406 C 44.601562 241.691406 44.414062 244.839844 41.972656 244.222656 C 39.535156 243.605469 34.941406 240.539062 32.675781 242.828125 C 30.324219 245.207031 31.160156 248.855469 34.277344 253.148438 C 37.398438 257.445312 43.886719 267.105469 44.46875 267.980469 C 45.042969 268.839844 45.273438 270.453125 43.542969 270.296875 C 41.8125 270.140625 30.136719 266.183594 28.589844 271.835938 C 27.042969 277.492188 37.699219 288.027344 38.84375 289.203125 C 39.984375 290.375 40.046875 291.117188 39.582031 291.828125 C 39.121094 292.539062 35.320312 290.839844 31.953125 289.847656 C 28.585938 288.859375 24.507812 288.304688 23.890625 291.640625 C 23.269531 294.976562 27.964844 304.738281 45.539062 315 L 53.996094 319.222656 L 61.996094 314.117188 C 78.457031 302.148438 82.152344 291.964844 81.203125 288.707031 C 80.253906 285.449219 76.25 286.414062 73 287.734375 C 69.75 289.054688 66.136719 291.125 65.605469 290.464844 C 65.074219 289.804688 65.0625 289.0625 66.082031 287.777344 C 67.101562 286.496094 76.648438 274.945312 74.542969 269.476562 C 72.441406 264.003906 61.21875 269.109375 59.511719 269.4375 C 57.808594 269.765625 57.875 268.136719 58.359375 267.226562 C 58.851562 266.296875 64.339844 256.035156 67.015625 251.449219 C 69.6875 246.863281 70.15625 243.152344 67.578125 241.023438 C 65.09375 238.96875 60.832031 242.476562 58.464844 243.335938 C 56.097656 244.199219 55.597656 241.082031 55.597656 241.082031 C 55.597656 241.082031 56.28125 233.402344 55.441406 219.207031 C 54.601562 205.007812 48.191406 206.15625 48.191406 206.15625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(87.843137%,87.843137%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 48.820312 218.882812 C 48.820312 218.882812 48.835938 218.980469 48.855469 219.179688 C 48.871094 219.390625 48.890625 219.679688 48.921875 220.050781 C 48.972656 220.832031 49.050781 221.960938 49.148438 223.40625 C 49.34375 226.320312 49.59375 230.539062 49.878906 235.753906 C 50.460938 246.183594 51.136719 260.597656 51.832031 276.519531 C 52.527344 292.449219 53.167969 306.863281 53.691406 317.296875 C 53.957031 322.5 54.171875 326.71875 54.320312 329.648438 C 54.390625 331.09375 54.445312 332.222656 54.488281 333.007812 C 54.5 333.378906 54.511719 333.671875 54.523438 333.878906 C 54.527344 334.078125 54.523438 334.179688 54.523438 334.179688 C 54.523438 334.179688 54.503906 334.078125 54.488281 333.882812 C 54.472656 333.671875 54.449219 333.382812 54.421875 333.011719 C 54.367188 332.230469 54.292969 331.101562 54.191406 329.65625 C 54 326.742188 53.75 322.523438 53.460938 317.308594 C 52.882812 306.878906 52.203125 292.460938 51.507812 276.535156 C 50.8125 260.613281 50.171875 246.199219 49.652344 235.769531 C 49.386719 230.5625 49.171875 226.347656 49.023438 223.414062 C 48.949219 221.96875 48.894531 220.839844 48.855469 220.054688 C 48.839844 219.683594 48.828125 219.390625 48.820312 219.179688 C 48.8125 218.984375 48.820312 218.882812 48.820312 218.882812 Z M 48.820312 218.882812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(87.843137%,87.843137%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 38.925781 247.378906 C 38.941406 247.363281 39.128906 247.519531 39.453125 247.816406 C 39.777344 248.109375 40.234375 248.554688 40.792969 249.105469 C 41.910156 250.210938 43.410156 251.777344 45.03125 253.535156 C 46.621094 255.273438 48.058594 256.84375 49.167969 258.0625 C 49.660156 258.597656 50.082031 259.050781 50.425781 259.425781 C 50.726562 259.746094 50.882812 259.933594 50.867188 259.949219 C 50.851562 259.964844 50.664062 259.808594 50.335938 259.515625 C 50.011719 259.21875 49.554688 258.777344 49.003906 258.21875 C 47.898438 257.101562 46.417969 255.515625 44.792969 253.757812 C 43.195312 252.03125 41.746094 250.472656 40.628906 249.265625 C 40.132812 248.730469 39.707031 248.277344 39.363281 247.90625 C 39.066406 247.582031 38.910156 247.394531 38.925781 247.378906 Z M 38.925781 247.378906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(87.843137%,87.843137%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 51.707031 259.671875 C 51.640625 259.609375 54.734375 256.371094 58.609375 252.4375 C 62.488281 248.507812 65.683594 245.371094 65.746094 245.433594 C 65.8125 245.496094 62.71875 248.734375 58.839844 252.667969 C 54.964844 256.597656 51.769531 259.734375 51.707031 259.671875 Z M 51.707031 259.671875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(87.843137%,87.843137%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 51.671875 284.171875 C 51.660156 284.152344 51.871094 284.019531 52.261719 283.796875 C 52.710938 283.542969 53.265625 283.234375 53.914062 282.871094 C 55.308594 282.085938 57.234375 280.996094 59.3125 279.71875 C 61.394531 278.445312 63.242188 277.226562 64.570312 276.335938 C 65.191406 275.921875 65.71875 275.570312 66.148438 275.285156 C 66.523438 275.039062 66.734375 274.910156 66.75 274.929688 C 66.761719 274.945312 66.574219 275.109375 66.222656 275.386719 C 65.867188 275.664062 65.351562 276.054688 64.699219 276.523438 C 63.402344 277.464844 61.570312 278.714844 59.480469 279.992188 C 57.394531 281.277344 55.445312 282.335938 54.023438 283.070312 C 53.308594 283.433594 52.726562 283.722656 52.316406 283.910156 C 51.910156 284.097656 51.679688 284.191406 51.671875 284.171875 Z M 51.671875 284.171875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(87.843137%,87.843137%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 37.664062 275.597656 C 37.675781 275.578125 37.882812 275.675781 38.246094 275.871094 C 38.613281 276.066406 39.136719 276.359375 39.78125 276.726562 C 41.066406 277.457031 42.835938 278.484375 44.777344 279.640625 C 46.71875 280.792969 48.464844 281.855469 49.722656 282.636719 C 50.351562 283.027344 50.859375 283.347656 51.203125 283.578125 C 51.546875 283.804688 51.734375 283.941406 51.722656 283.960938 C 51.710938 283.980469 51.503906 283.878906 51.136719 283.6875 C 50.773438 283.492188 50.25 283.199219 49.605469 282.832031 C 48.320312 282.101562 46.550781 281.070312 44.609375 279.917969 C 42.667969 278.761719 40.921875 277.703125 39.664062 276.921875 C 39.035156 276.53125 38.527344 276.207031 38.183594 275.980469 C 37.835938 275.753906 37.652344 275.617188 37.664062 275.597656 Z M 37.664062 275.597656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(87.843137%,87.843137%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 34.882812 297.226562 C 34.894531 297.207031 35.160156 297.335938 35.628906 297.585938 C 36.148438 297.871094 36.808594 298.238281 37.597656 298.671875 C 39.25 299.601562 41.523438 300.902344 44.027344 302.359375 C 46.53125 303.8125 48.785156 305.148438 50.410156 306.128906 C 51.175781 306.597656 51.820312 306.992188 52.328125 307.300781 C 52.777344 307.585938 53.019531 307.753906 53.007812 307.769531 C 52.996094 307.789062 52.730469 307.660156 52.261719 307.410156 C 51.742188 307.125 51.082031 306.761719 50.296875 306.324219 C 48.640625 305.398438 46.367188 304.09375 43.863281 302.636719 C 41.363281 301.183594 39.105469 299.847656 37.480469 298.871094 C 36.714844 298.398438 36.070312 298.007812 35.5625 297.695312 C 35.117188 297.410156 34.871094 297.246094 34.882812 297.226562 Z M 34.882812 297.226562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(87.843137%,87.843137%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 52.644531 307.394531 C 52.632812 307.375 52.894531 307.203125 53.378906 306.902344 C 53.917969 306.578125 54.609375 306.15625 55.433594 305.652344 C 57.167969 304.597656 59.5625 303.128906 62.15625 301.433594 C 64.753906 299.746094 67.066406 298.15625 68.730469 296.996094 C 69.527344 296.441406 70.191406 295.980469 70.707031 295.621094 C 71.175781 295.300781 71.441406 295.128906 71.457031 295.148438 C 71.46875 295.164062 71.226562 295.371094 70.78125 295.722656 C 70.335938 296.078125 69.683594 296.578125 68.863281 297.179688 C 67.230469 298.390625 64.933594 300.011719 62.332031 301.707031 C 59.730469 303.402344 57.316406 304.839844 55.550781 305.847656 C 54.664062 306.351562 53.945312 306.75 53.441406 307.011719 C 52.9375 307.277344 52.65625 307.414062 52.644531 307.394531 Z M 52.644531 307.394531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(87.843137%,87.843137%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 65.351562 321.988281 L 41.960938 321.988281 L 49.597656 379.78125 L 57.71875 379.78125 Z M 65.351562 321.988281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.078431%,96.078431%,96.078431%)",
      fillOpacity: 1
    },
    d: "M 43.175781 329.09375 C 43.167969 329.097656 43.199219 329.175781 43.300781 329.296875 C 43.398438 329.421875 43.582031 329.582031 43.863281 329.703125 C 44.417969 329.945312 45.394531 329.964844 46.335938 329.398438 C 47.277344 328.878906 48.101562 327.855469 49.367188 327.402344 C 50.625 326.921875 52.179688 327.007812 53.667969 327.488281 C 55.175781 327.953125 56.488281 328.71875 57.675781 329.429688 C 58.863281 330.136719 59.953125 330.769531 60.933594 331.175781 C 61.902344 331.601562 62.75 331.796875 63.335938 331.871094 C 63.628906 331.910156 63.859375 331.921875 64.011719 331.917969 C 64.167969 331.917969 64.25 331.910156 64.25 331.898438 C 64.265625 331.820312 62.925781 331.832031 61.042969 330.929688 C 60.097656 330.496094 59.035156 329.851562 57.855469 329.128906 C 56.683594 328.402344 55.339844 327.605469 53.78125 327.125 C 52.242188 326.628906 50.589844 326.539062 49.242188 327.074219 C 48.570312 327.328125 48.003906 327.730469 47.535156 328.128906 C 47.058594 328.527344 46.628906 328.898438 46.195312 329.167969 C 45.339844 329.722656 44.441406 329.742188 43.917969 329.5625 C 43.378906 329.375 43.203125 329.058594 43.175781 329.09375 Z M 43.175781 329.09375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.078431%,96.078431%,96.078431%)",
      fillOpacity: 1
    },
    d: "M 44.027344 339.738281 C 44.058594 339.757812 44.214844 339.5 44.578125 339.117188 C 44.953125 338.746094 45.5625 338.261719 46.449219 337.933594 C 47.324219 337.59375 48.453125 337.394531 49.699219 337.441406 C 50.953125 337.484375 52.320312 337.761719 53.769531 337.996094 C 55.222656 338.242188 56.65625 338.347656 57.9375 338.167969 C 59.222656 338.003906 60.335938 337.636719 61.21875 337.234375 C 62.105469 336.828125 62.761719 336.386719 63.191406 336.0625 C 63.621094 335.734375 63.828125 335.511719 63.816406 335.5 C 63.769531 335.433594 62.867188 336.242188 61.109375 336.984375 C 60.234375 337.347656 59.140625 337.679688 57.898438 337.820312 C 56.652344 337.976562 55.273438 337.859375 53.832031 337.621094 C 52.390625 337.386719 51.003906 337.113281 49.710938 337.089844 C 48.417969 337.0625 47.25 337.296875 46.347656 337.679688 C 45.433594 338.058594 44.820312 338.601562 44.46875 339.015625 C 44.300781 339.234375 44.179688 339.40625 44.117188 339.535156 C 44.046875 339.660156 44.015625 339.730469 44.027344 339.738281 Z M 44.027344 339.738281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.078431%,96.078431%,96.078431%)",
      fillOpacity: 1
    },
    d: "M 62.703125 345.433594 C 62.710938 345.417969 62.496094 345.269531 62.058594 345.101562 C 61.625 344.929688 60.957031 344.75 60.121094 344.683594 C 59.28125 344.617188 58.277344 344.671875 57.1875 344.851562 C 56.097656 345.027344 54.929688 345.332031 53.699219 345.589844 C 52.472656 345.847656 51.289062 346.023438 50.21875 345.984375 C 49.144531 345.945312 48.191406 345.710938 47.453125 345.386719 C 45.945312 344.726562 45.410156 343.761719 45.355469 343.824219 C 45.339844 343.832031 45.445312 344.074219 45.75 344.433594 C 46.050781 344.792969 46.578125 345.253906 47.335938 345.628906 C 48.097656 346.003906 49.085938 346.277344 50.203125 346.335938 C 51.320312 346.394531 52.539062 346.226562 53.777344 345.964844 C 55.019531 345.699219 56.179688 345.390625 57.25 345.199219 C 58.316406 345 59.289062 344.921875 60.105469 344.953125 C 61.746094 345.007812 62.679688 345.503906 62.703125 345.433594 Z M 62.703125 345.433594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.078431%,96.078431%,96.078431%)",
      fillOpacity: 1
    },
    d: "M 46.09375 353.449219 C 46.105469 353.511719 46.929688 352.929688 48.367188 353.222656 C 49.070312 353.347656 49.859375 353.707031 50.742188 354.105469 C 51.625 354.519531 52.6875 354.871094 53.828125 354.957031 C 56.125 355.179688 58.167969 354.4375 59.421875 353.660156 C 60.066406 353.28125 60.511719 352.871094 60.816406 352.589844 C 61.101562 352.285156 61.246094 352.113281 61.226562 352.09375 C 61.175781 352.039062 60.5625 352.730469 59.289062 353.425781 C 58.035156 354.121094 56.0625 354.789062 53.859375 354.578125 C 51.644531 354.453125 49.945312 353.128906 48.410156 352.957031 C 47.664062 352.84375 47.035156 352.953125 46.648438 353.109375 C 46.25 353.261719 46.085938 353.4375 46.09375 353.449219 Z M 46.09375 353.449219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.078431%,96.078431%,96.078431%)",
      fillOpacity: 1
    },
    d: "M 47.398438 364.542969 C 47.398438 364.585938 48.183594 364.582031 49.347656 364.15625 C 50.523438 363.761719 51.980469 362.863281 53.679688 362.1875 C 54.53125 361.863281 55.386719 361.660156 56.164062 361.664062 C 56.945312 361.667969 57.636719 361.859375 58.164062 362.121094 C 59.238281 362.65625 59.550781 363.417969 59.609375 363.367188 C 59.625 363.363281 59.578125 363.171875 59.386719 362.875 C 59.199219 362.582031 58.839844 362.199219 58.292969 361.882812 C 57.742188 361.570312 57.007812 361.339844 56.171875 361.3125 C 55.332031 361.289062 54.429688 361.492188 53.542969 361.832031 C 51.78125 362.53125 50.375 363.460938 49.25 363.90625 C 48.140625 364.382812 47.390625 364.480469 47.398438 364.542969 Z M 47.398438 364.542969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.078431%,96.078431%,96.078431%)",
      fillOpacity: 1
    },
    d: "M 48.542969 369.703125 C 48.53125 369.753906 49.09375 369.953125 50.027344 370.183594 C 50.957031 370.417969 52.265625 370.664062 53.726562 370.808594 C 55.191406 370.953125 56.523438 370.964844 57.480469 370.917969 C 58.441406 370.871094 59.03125 370.785156 59.027344 370.734375 C 59.023438 370.621094 56.65625 370.71875 53.765625 370.429688 C 50.875 370.152344 48.574219 369.59375 48.542969 369.703125 Z M 48.542969 369.703125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 377.015625 378.851562 C 377.015625 378.964844 297.402344 379.058594 199.21875 379.058594 C 101 379.058594 21.40625 378.964844 21.40625 378.851562 C 21.40625 378.734375 101 378.644531 199.21875 378.644531 C 297.402344 378.644531 377.015625 378.734375 377.015625 378.851562 Z M 377.015625 378.851562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,74.509804%,61.568627%)",
      fillOpacity: 1
    },
    d: "M 121.882812 128.769531 C 121.882812 128.769531 124.0625 115.722656 124.582031 114.730469 C 125.097656 113.738281 131.113281 107.636719 131.824219 107.511719 C 132.535156 107.386719 142.015625 104.410156 141.492188 105.886719 C 140.964844 107.367188 134.316406 109.363281 134.316406 109.363281 L 133.683594 110.15625 C 133.683594 110.15625 139.367188 108.308594 140.777344 108.355469 C 142.078125 108.398438 142.3125 109.746094 141.296875 110.136719 C 140.277344 110.527344 135.269531 111.988281 135.082031 112.300781 C 134.898438 112.613281 140.660156 110.96875 141.382812 110.996094 C 142.359375 111.039062 143.066406 112.273438 142.070312 112.691406 C 141.484375 112.9375 135.910156 114.21875 135.910156 114.21875 C 135.910156 114.21875 140.5625 113.671875 141.085938 113.8125 C 141.945312 114.046875 141.871094 115.085938 140.929688 115.335938 C 140.28125 115.507812 136.878906 115.652344 136.011719 115.886719 C 136.011719 115.886719 135.371094 116.433594 135.394531 118.15625 C 135.417969 119.878906 133.175781 124.472656 133.175781 124.472656 Z M 121.882812 128.769531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.156863%,60%,43.137255%)",
      fillOpacity: 1
    },
    d: "M 141.484375 105.917969 C 141.519531 105.953125 141.042969 106.480469 140.089844 107.128906 C 139.609375 107.453125 139.011719 107.796875 138.3125 108.101562 C 137.605469 108.367188 136.824219 108.636719 136.003906 108.921875 C 135.394531 109.128906 134.808594 109.328125 134.253906 109.515625 L 134.347656 109.457031 C 132.542969 111.261719 131.1875 112.523438 131.113281 112.460938 C 131.039062 112.394531 132.269531 111.019531 134.042969 109.175781 L 134.078125 109.140625 L 134.136719 109.121094 C 134.6875 108.925781 135.265625 108.726562 135.863281 108.511719 C 136.667969 108.242188 137.433594 107.980469 138.164062 107.734375 C 138.84375 107.460938 139.4375 107.152344 139.921875 106.875 C 140.890625 106.308594 141.4375 105.867188 141.484375 105.917969 Z M 141.484375 105.917969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 267.789062 272.097656 L 138.652344 258.792969 C 134.703125 258.386719 131.832031 254.855469 132.238281 250.90625 L 154.601562 33.800781 C 155.179688 28.191406 160.199219 24.109375 165.808594 24.6875 L 288.929688 37.371094 C 294.542969 37.949219 298.621094 42.964844 298.042969 48.578125 L 275.675781 265.683594 C 275.273438 269.632812 271.738281 272.503906 267.789062 272.097656 Z M 267.789062 272.097656 "
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)",
    fill: "#050505"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 254.761719 270.753906 L 125.625 257.453125 C 121.671875 257.042969 118.800781 253.511719 119.207031 249.5625 L 141.574219 32.457031 C 142.152344 26.847656 147.167969 22.765625 152.777344 23.34375 L 275.902344 36.027344 C 281.511719 36.605469 285.589844 41.625 285.011719 47.234375 L 262.648438 264.339844 C 262.242188 268.289062 258.710938 271.164062 254.761719 270.753906 Z M 254.761719 270.753906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 186.886719 233.035156 L 142.359375 228.449219 C 141.296875 228.339844 140.523438 227.386719 140.632812 226.324219 L 142.4375 208.800781 C 142.546875 207.738281 143.496094 206.964844 144.5625 207.074219 L 189.089844 211.664062 C 190.152344 211.773438 190.925781 212.722656 190.816406 213.785156 L 189.011719 231.308594 C 188.902344 232.371094 187.953125 233.144531 186.886719 233.035156 Z M 186.886719 233.035156 "
  }), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)",
    fill: "#050505"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 145.617188 95.726562 L 150.574219 47.625 L 273.203125 60.261719 L 268.246094 108.363281 Z M 145.617188 95.726562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 268.246094 108.355469 C 268.246094 108.355469 268.265625 108.058594 268.320312 107.496094 C 268.375 106.925781 268.453125 106.09375 268.558594 105.003906 C 268.777344 102.8125 269.097656 99.597656 269.507812 95.445312 C 270.34375 87.152344 271.554688 75.140625 273.058594 60.234375 L 273.1875 60.394531 C 242.324219 57.230469 198.769531 52.765625 150.554688 47.824219 L 150.546875 47.824219 L 150.773438 47.636719 C 149.039062 64.460938 147.363281 80.714844 145.8125 95.742188 L 145.632812 95.523438 C 181.117188 99.214844 211.746094 102.402344 233.511719 104.667969 C 244.402344 105.8125 253.074219 106.726562 259.035156 107.355469 C 262.011719 107.671875 264.304688 107.914062 265.867188 108.082031 C 266.640625 108.167969 267.230469 108.234375 267.636719 108.277344 C 268.035156 108.324219 268.246094 108.355469 268.246094 108.355469 C 268.246094 108.355469 268.050781 108.34375 267.660156 108.304688 C 267.257812 108.269531 266.675781 108.210938 265.910156 108.136719 C 264.359375 107.984375 262.074219 107.757812 259.113281 107.464844 C 253.164062 106.863281 244.503906 105.992188 233.625 104.894531 C 211.820312 102.671875 181.140625 99.542969 145.589844 95.921875 L 145.394531 95.898438 L 145.414062 95.699219 C 146.960938 80.675781 148.628906 64.421875 150.359375 47.59375 L 150.382812 47.386719 L 150.589844 47.410156 L 150.597656 47.410156 C 198.808594 52.402344 242.355469 56.910156 273.21875 60.105469 L 273.359375 60.121094 L 273.34375 60.265625 C 271.773438 75.203125 270.507812 87.238281 269.632812 95.550781 C 269.191406 99.683594 268.847656 102.886719 268.613281 105.070312 C 268.496094 106.144531 268.40625 106.964844 268.347656 107.53125 C 268.285156 108.078125 268.246094 108.355469 268.246094 108.355469 Z M 268.246094 108.355469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 167.53125 138.429688 L 150 136.625 C 149.085938 136.53125 148.417969 135.710938 148.511719 134.796875 L 150.320312 117.265625 C 150.414062 116.351562 151.230469 115.6875 152.148438 115.777344 L 169.679688 117.585938 C 170.59375 117.679688 171.257812 118.496094 171.164062 119.414062 L 169.359375 136.945312 C 169.265625 137.859375 168.445312 138.523438 167.53125 138.429688 Z M 167.53125 138.429688 "
  }), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface11",
    mask: "url(#mask2)",
    fill: "#050505"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 164.3125 138.097656 L 146.78125 136.292969 C 145.867188 136.199219 145.199219 135.378906 145.296875 134.464844 L 147.101562 116.933594 C 147.195312 116.019531 148.011719 115.355469 148.929688 115.449219 L 166.460938 117.257812 C 167.375 117.351562 168.039062 118.167969 167.945312 119.082031 L 166.140625 136.613281 C 166.042969 137.527344 165.226562 138.195312 164.3125 138.097656 Z M 164.3125 138.097656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 158.546875 122.484375 L 157.652344 131.171875 L 155.640625 130.964844 L 156.371094 123.890625 L 154.632812 123.710938 L 154.800781 122.097656 Z M 158.546875 122.484375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 196.597656 141.425781 L 179.066406 139.617188 C 178.152344 139.523438 177.488281 138.707031 177.582031 137.792969 L 179.386719 120.261719 C 179.480469 119.34375 180.300781 118.679688 181.214844 118.773438 L 198.746094 120.578125 C 199.660156 120.675781 200.324219 121.492188 200.230469 122.40625 L 198.425781 139.9375 C 198.332031 140.855469 197.511719 141.519531 196.597656 141.425781 Z M 196.597656 141.425781 "
  }), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface14",
    mask: "url(#mask3)",
    fill: "#050505"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 193.378906 141.09375 L 175.847656 139.289062 C 174.933594 139.195312 174.265625 138.375 174.363281 137.460938 L 176.167969 119.929688 C 176.261719 119.015625 177.078125 118.347656 177.996094 118.445312 L 195.527344 120.25 C 196.441406 120.34375 197.105469 121.164062 197.011719 122.078125 L 195.207031 139.609375 C 195.109375 140.523438 194.292969 141.1875 193.378906 141.09375 Z M 193.378906 141.09375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 190.027344 132.851562 L 189.859375 134.492188 L 183.292969 133.816406 L 183.429688 132.511719 L 187.105469 129.691406 C 187.949219 129.039062 188.132812 128.605469 188.175781 128.183594 C 188.246094 127.5 187.816406 127.054688 186.898438 126.960938 C 186.152344 126.886719 185.492188 127.105469 185.007812 127.644531 L 183.640625 126.550781 C 184.414062 125.640625 185.695312 125.132812 187.257812 125.292969 C 189.195312 125.492188 190.382812 126.621094 190.21875 128.195312 C 190.132812 129.039062 189.816406 129.785156 188.484375 130.789062 L 186.292969 132.46875 Z M 190.027344 132.851562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 226.730469 144.527344 L 209.199219 142.722656 C 208.285156 142.628906 207.621094 141.808594 207.714844 140.894531 L 209.519531 123.363281 C 209.613281 122.449219 210.433594 121.785156 211.347656 121.878906 L 228.878906 123.683594 C 229.792969 123.777344 230.457031 124.597656 230.363281 125.511719 L 228.558594 143.042969 C 228.464844 143.957031 227.644531 144.625 226.730469 144.527344 Z M 226.730469 144.527344 "
  }), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface17",
    mask: "url(#mask4)",
    fill: "#050505"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 223.511719 144.199219 L 205.980469 142.390625 C 205.066406 142.296875 204.398438 141.480469 204.496094 140.5625 L 206.300781 123.03125 C 206.394531 122.117188 207.214844 121.453125 208.128906 121.546875 L 225.660156 123.351562 C 226.574219 123.445312 227.238281 124.265625 227.144531 125.179688 L 225.339844 142.710938 C 225.246094 143.625 224.425781 144.292969 223.511719 144.199219 Z M 223.511719 144.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 220.191406 134.929688 C 220.039062 136.394531 218.773438 137.621094 216.304688 137.363281 C 215.089844 137.238281 213.867188 136.773438 213.085938 136.09375 L 214.027344 134.632812 C 214.632812 135.199219 215.523438 135.578125 216.429688 135.671875 C 217.433594 135.773438 218.097656 135.429688 218.167969 134.722656 C 218.238281 134.066406 217.796875 133.605469 216.652344 133.488281 L 215.734375 133.394531 L 215.871094 132.066406 L 217.867188 130.226562 L 214.167969 129.847656 L 214.335938 128.234375 L 220.417969 128.859375 L 220.28125 130.164062 L 218.09375 132.195312 C 219.628906 132.605469 220.324219 133.652344 220.191406 134.929688 Z M 220.191406 134.929688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 256.863281 147.632812 L 239.332031 145.828125 C 238.417969 145.734375 237.753906 144.914062 237.847656 144 L 239.652344 126.46875 C 239.746094 125.554688 240.5625 124.890625 241.480469 124.984375 L 259.011719 126.789062 C 259.925781 126.882812 260.589844 127.703125 260.496094 128.617188 L 258.691406 146.148438 C 258.597656 147.0625 257.777344 147.726562 256.863281 147.632812 Z M 256.863281 147.632812 "
  }), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface20",
    mask: "url(#mask5)",
    fill: "#050505"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 253.71875 147.300781 L 236.1875 145.496094 C 235.269531 145.402344 234.605469 144.582031 234.699219 143.667969 L 236.507812 126.136719 C 236.601562 125.222656 237.417969 124.558594 238.335938 124.652344 L 255.867188 126.457031 C 256.78125 126.554688 257.445312 127.371094 257.351562 128.285156 L 255.542969 145.816406 C 255.449219 146.730469 254.632812 147.394531 253.71875 147.300781 Z M 253.71875 147.300781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 241.238281 135.5625 L 241.320312 134.765625 L 250.628906 135.726562 L 250.546875 136.519531 Z M 241.238281 135.5625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 247.859375 131.730469 C 247.773438 132.5625 247.03125 133.167969 246.195312 133.082031 C 245.363281 132.996094 244.757812 132.253906 244.84375 131.417969 C 244.929688 130.585938 245.675781 129.980469 246.507812 130.066406 C 247.339844 130.152344 247.945312 130.894531 247.859375 131.730469 Z M 247.859375 131.730469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 247.023438 139.847656 C 246.9375 140.679688 246.195312 141.285156 245.359375 141.199219 C 244.527344 141.113281 243.921875 140.367188 244.007812 139.535156 C 244.09375 138.703125 244.839844 138.097656 245.671875 138.183594 C 246.503906 138.269531 247.109375 139.011719 247.023438 139.847656 Z M 247.023438 139.847656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 164.386719 168.964844 L 146.855469 167.160156 C 145.9375 167.066406 145.273438 166.246094 145.367188 165.332031 L 147.175781 147.800781 C 147.269531 146.886719 148.085938 146.222656 149 146.316406 L 166.53125 148.121094 C 167.449219 148.21875 168.113281 149.035156 168.019531 149.949219 L 166.210938 167.480469 C 166.117188 168.394531 165.300781 169.058594 164.386719 168.964844 Z M 164.386719 168.964844 "
  }), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface23",
    mask: "url(#mask6)",
    fill: "#050505"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 161.167969 168.632812 L 143.636719 166.828125 C 142.71875 166.734375 142.054688 165.917969 142.148438 165 L 143.957031 147.46875 C 144.050781 146.554688 144.867188 145.890625 145.78125 145.984375 L 163.3125 147.789062 C 164.230469 147.886719 164.894531 148.703125 164.800781 149.617188 L 162.992188 167.148438 C 162.898438 168.0625 162.082031 168.730469 161.167969 168.632812 Z M 161.167969 168.632812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 157.230469 160.144531 L 155.816406 160 L 155.628906 161.824219 L 153.667969 161.621094 L 153.855469 159.796875 L 149.175781 159.316406 L 149.316406 157.964844 L 153.980469 152.875 L 156.089844 153.09375 L 151.753906 157.925781 L 154.085938 158.164062 L 154.253906 156.539062 L 156.152344 156.734375 L 155.984375 158.363281 L 157.398438 158.507812 Z M 157.230469 160.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 193.453125 171.960938 L 175.921875 170.152344 C 175.003906 170.058594 174.339844 169.242188 174.433594 168.328125 L 176.242188 150.796875 C 176.335938 149.878906 177.152344 149.214844 178.066406 149.308594 L 195.597656 151.113281 C 196.515625 151.210938 197.179688 152.027344 197.085938 152.941406 L 195.277344 170.472656 C 195.183594 171.390625 194.367188 172.054688 193.453125 171.960938 Z M 193.453125 171.960938 "
  }), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface26",
    mask: "url(#mask7)",
    fill: "#050505"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 190.234375 171.628906 L 172.703125 169.824219 C 171.785156 169.726562 171.121094 168.910156 171.214844 167.996094 L 173.023438 150.464844 C 173.117188 149.546875 173.933594 148.882812 174.847656 148.976562 L 192.378906 150.785156 C 193.296875 150.878906 193.960938 151.695312 193.867188 152.613281 L 192.058594 170.144531 C 191.964844 171.058594 191.148438 171.722656 190.234375 171.628906 Z M 190.234375 171.628906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 186.035156 162.195312 C 185.875 163.734375 184.609375 164.960938 182.128906 164.703125 C 180.921875 164.578125 179.691406 164.113281 178.910156 163.433594 L 179.863281 161.976562 C 180.46875 162.539062 181.34375 162.917969 182.25 163.011719 C 183.257812 163.113281 183.921875 162.757812 183.992188 162.046875 C 184.0625 161.367188 183.664062 160.875 182.085938 160.710938 L 179.867188 160.480469 L 180.816406 155.640625 L 186.117188 156.183594 L 185.949219 157.796875 L 182.324219 157.425781 L 182.019531 159.0625 L 182.726562 159.132812 C 185.296875 159.398438 186.191406 160.660156 186.035156 162.195312 Z M 186.035156 162.195312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 223.585938 175.066406 L 206.054688 173.257812 C 205.136719 173.164062 204.472656 172.347656 204.566406 171.429688 L 206.375 153.898438 C 206.46875 152.984375 207.285156 152.320312 208.203125 152.414062 L 225.734375 154.222656 C 226.648438 154.316406 227.3125 155.132812 227.21875 156.046875 L 225.410156 173.578125 C 225.316406 174.492188 224.5 175.160156 223.585938 175.066406 Z M 223.585938 175.066406 "
  }), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface29",
    mask: "url(#mask8)",
    fill: "#050505"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 220.367188 174.734375 L 202.835938 172.925781 C 201.917969 172.832031 201.253906 172.011719 201.347656 171.097656 L 203.15625 153.566406 C 203.25 152.652344 204.066406 151.988281 204.980469 152.082031 L 222.511719 153.890625 C 223.429688 153.984375 224.09375 154.800781 224 155.714844 L 222.191406 173.246094 C 222.097656 174.160156 221.28125 174.828125 220.367188 174.734375 Z M 220.367188 174.734375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 216.777344 165.351562 C 216.59375 167.125 215.027344 168.09375 213.191406 167.902344 C 210.796875 167.65625 209.460938 166.003906 209.75 163.199219 C 210.0625 160.195312 212.042969 158.707031 214.664062 158.976562 C 215.582031 159.070312 216.453125 159.371094 217.023438 159.820312 L 216.125 161.222656 C 215.675781 160.847656 215.128906 160.679688 214.542969 160.617188 C 213.09375 160.46875 212.070312 161.230469 211.839844 162.886719 C 212.398438 162.429688 213.160156 162.242188 214.066406 162.335938 C 215.742188 162.511719 216.945312 163.710938 216.777344 165.351562 Z M 214.820312 165.25 C 214.902344 164.457031 214.371094 163.886719 213.476562 163.792969 C 212.59375 163.703125 211.917969 164.1875 211.839844 164.941406 C 211.761719 165.6875 212.265625 166.292969 213.234375 166.390625 C 214.089844 166.480469 214.738281 166.042969 214.820312 165.25 Z M 214.820312 165.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 253.71875 178.167969 L 236.1875 176.363281 C 235.269531 176.269531 234.605469 175.449219 234.699219 174.535156 L 236.507812 157.003906 C 236.601562 156.089844 237.417969 155.425781 238.335938 155.519531 L 255.867188 157.324219 C 256.78125 157.417969 257.445312 158.238281 257.351562 159.152344 L 255.542969 176.683594 C 255.449219 177.597656 254.632812 178.261719 253.71875 178.167969 Z M 253.71875 178.167969 "
  }), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface32",
    mask: "url(#mask9)",
    fill: "#050505"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 250.5 177.835938 L 232.96875 176.03125 C 232.050781 175.9375 231.386719 175.121094 231.480469 174.203125 L 233.289062 156.671875 C 233.382812 155.757812 234.199219 155.09375 235.113281 155.1875 L 252.644531 156.992188 C 253.5625 157.089844 254.226562 157.90625 254.132812 158.820312 L 252.324219 176.351562 C 252.230469 177.265625 251.414062 177.929688 250.5 177.835938 Z M 250.5 177.835938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 238.878906 169.09375 L 246.226562 163.300781 L 246.722656 163.929688 L 239.375 169.722656 Z M 238.878906 169.09375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 239.550781 163.140625 L 240.167969 162.636719 L 246.074219 169.894531 L 245.453125 170.398438 Z M 239.550781 163.140625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 161.265625 199.253906 L 143.734375 197.445312 C 142.820312 197.351562 142.152344 196.535156 142.246094 195.621094 L 144.054688 178.089844 C 144.148438 177.171875 144.964844 176.507812 145.882812 176.601562 L 163.414062 178.40625 C 164.328125 178.503906 164.992188 179.320312 164.898438 180.234375 L 163.09375 197.765625 C 162.996094 198.679688 162.179688 199.347656 161.265625 199.253906 Z M 161.265625 199.253906 "
  }), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface35",
    mask: "url(#mask10)",
    fill: "#050505"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 158.046875 198.921875 L 140.515625 197.117188 C 139.601562 197.023438 138.933594 196.203125 139.03125 195.289062 L 140.835938 177.757812 C 140.929688 176.84375 141.746094 176.175781 142.664062 176.273438 L 160.195312 178.078125 C 161.109375 178.171875 161.773438 178.992188 161.679688 179.90625 L 159.871094 197.4375 C 159.777344 198.351562 158.960938 199.015625 158.046875 198.921875 Z M 158.046875 198.921875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 153.664062 183.449219 L 153.53125 184.753906 L 149.542969 191.804688 L 147.359375 191.578125 L 151.199219 184.851562 L 148.320312 184.554688 L 148.175781 185.96875 L 146.386719 185.785156 L 146.703125 182.734375 Z M 153.664062 183.449219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 190.332031 202.246094 L 172.800781 200.441406 C 171.886719 200.347656 171.21875 199.527344 171.3125 198.613281 L 173.121094 181.082031 C 173.214844 180.167969 174.03125 179.503906 174.949219 179.597656 L 192.480469 181.402344 C 193.394531 181.496094 194.058594 182.316406 193.964844 183.230469 L 192.160156 200.761719 C 192.066406 201.675781 191.246094 202.339844 190.332031 202.246094 Z M 190.332031 202.246094 "
  }), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface38",
    mask: "url(#mask11)",
    fill: "#050505"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 187.113281 201.914062 L 169.582031 200.109375 C 168.667969 200.015625 168 199.199219 168.09375 198.28125 L 169.902344 180.75 C 169.996094 179.835938 170.8125 179.171875 171.730469 179.265625 L 189.261719 181.070312 C 190.175781 181.164062 190.839844 181.984375 190.746094 182.898438 L 188.9375 200.429688 C 188.84375 201.34375 188.027344 202.007812 187.113281 201.914062 Z M 187.113281 201.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 183.601562 192.765625 C 183.429688 194.40625 181.859375 195.285156 179.652344 195.058594 C 177.457031 194.832031 176.109375 193.652344 176.277344 192.011719 C 176.375 191.082031 176.929688 190.4375 177.804688 190.101562 C 177.199219 189.636719 176.902344 188.992188 176.984375 188.210938 C 177.140625 186.683594 178.605469 185.867188 180.578125 186.070312 C 182.578125 186.277344 183.84375 187.375 183.6875 188.898438 C 183.605469 189.679688 183.167969 190.25 182.484375 190.582031 C 183.285156 191.09375 183.695312 191.835938 183.601562 192.765625 Z M 181.570312 192.496094 C 181.652344 191.726562 181.066406 191.191406 180.0625 191.085938 C 179.070312 190.984375 178.398438 191.390625 178.320312 192.160156 C 178.242188 192.929688 178.8125 193.476562 179.804688 193.582031 C 180.808594 193.683594 181.492188 193.265625 181.570312 192.496094 Z M 178.972656 188.503906 C 178.90625 189.160156 179.386719 189.625 180.203125 189.707031 C 181.035156 189.792969 181.609375 189.441406 181.675781 188.78125 C 181.746094 188.101562 181.246094 187.632812 180.425781 187.550781 C 179.621094 187.464844 179.042969 187.820312 178.972656 188.503906 Z M 178.972656 188.503906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 220.464844 205.351562 L 202.933594 203.542969 C 202.019531 203.449219 201.355469 202.632812 201.445312 201.71875 L 203.253906 184.1875 C 203.347656 183.269531 204.164062 182.605469 205.082031 182.699219 L 222.613281 184.507812 C 223.527344 184.601562 224.191406 185.417969 224.097656 186.335938 L 222.292969 203.867188 C 222.199219 204.78125 221.378906 205.445312 220.464844 205.351562 Z M 220.464844 205.351562 "
  }), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface41",
    mask: "url(#mask12)",
    fill: "#050505"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 217.246094 205.019531 L 199.714844 203.214844 C 198.800781 203.121094 198.132812 202.300781 198.230469 201.386719 L 200.035156 183.855469 C 200.128906 182.941406 200.945312 182.273438 201.863281 182.371094 L 219.394531 184.175781 C 220.308594 184.269531 220.972656 185.089844 220.878906 186.003906 L 219.074219 203.535156 C 218.976562 204.449219 218.160156 205.113281 217.246094 205.019531 Z M 217.246094 205.019531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 213.605469 193.828125 C 213.296875 196.828125 211.324219 198.320312 208.695312 198.046875 C 207.777344 197.953125 206.914062 197.652344 206.347656 197.203125 L 207.242188 195.804688 C 207.679688 196.175781 208.230469 196.34375 208.824219 196.40625 C 210.265625 196.554688 211.296875 195.796875 211.53125 194.125 C 210.96875 194.582031 210.195312 194.777344 209.289062 194.683594 C 207.613281 194.511719 206.410156 193.308594 206.578125 191.671875 C 206.761719 189.898438 208.328125 188.929688 210.164062 189.117188 C 212.574219 189.367188 213.894531 191.023438 213.605469 193.828125 Z M 211.515625 192.082031 C 211.59375 191.335938 211.089844 190.734375 210.132812 190.632812 C 209.277344 190.546875 208.632812 190.980469 208.550781 191.773438 C 208.46875 192.570312 209 193.140625 209.894531 193.230469 C 210.773438 193.320312 211.4375 192.839844 211.515625 192.082031 Z M 211.515625 192.082031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 250.597656 208.457031 L 233.066406 206.648438 C 232.152344 206.554688 231.488281 205.738281 231.578125 204.824219 L 233.386719 187.292969 C 233.480469 186.375 234.296875 185.710938 235.214844 185.804688 L 252.746094 187.613281 C 253.660156 187.707031 254.324219 188.523438 254.230469 189.4375 L 252.425781 206.96875 C 252.332031 207.886719 251.511719 208.550781 250.597656 208.457031 Z M 250.597656 208.457031 "
  }), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface44",
    mask: "url(#mask13)",
    fill: "#050505"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 247.378906 208.125 L 229.847656 206.316406 C 228.933594 206.222656 228.265625 205.40625 228.359375 204.492188 L 230.167969 186.960938 C 230.261719 186.042969 231.078125 185.378906 231.996094 185.472656 L 249.527344 187.28125 C 250.441406 187.375 251.105469 188.191406 251.011719 189.105469 L 249.203125 206.636719 C 249.109375 207.554688 248.292969 208.21875 247.378906 208.125 Z M 247.378906 208.125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 234.984375 196.726562 L 235.066406 195.933594 L 244.371094 196.890625 L 244.289062 197.6875 Z M 234.984375 196.726562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 217.316406 235.902344 L 199.785156 234.097656 C 198.871094 234.003906 198.207031 233.183594 198.300781 232.269531 L 200.105469 214.738281 C 200.199219 213.824219 201.019531 213.160156 201.933594 213.253906 L 219.464844 215.058594 C 220.378906 215.152344 221.042969 215.972656 220.949219 216.886719 L 219.144531 234.417969 C 219.050781 235.332031 218.230469 235.996094 217.316406 235.902344 Z M 217.316406 235.902344 "
  }), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface47",
    mask: "url(#mask14)",
    fill: "#050505"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 214.097656 235.570312 L 196.566406 233.765625 C 195.652344 233.671875 194.988281 232.851562 195.082031 231.9375 L 196.886719 214.40625 C 196.980469 213.492188 197.800781 212.828125 198.714844 212.921875 L 216.246094 214.726562 C 217.160156 214.820312 217.828125 215.636719 217.734375 216.554688 L 215.925781 234.085938 C 215.832031 235 215.011719 235.664062 214.097656 235.570312 Z M 214.097656 235.570312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 247.449219 239.007812 L 229.917969 237.199219 C 229.003906 237.105469 228.339844 236.289062 228.433594 235.375 L 230.238281 217.84375 C 230.335938 216.925781 231.152344 216.261719 232.066406 216.355469 L 249.597656 218.164062 C 250.511719 218.257812 251.179688 219.074219 251.085938 219.992188 L 249.277344 237.523438 C 249.183594 238.4375 248.363281 239.101562 247.449219 239.007812 Z M 247.449219 239.007812 "
  }), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface50",
    mask: "url(#mask15)",
    fill: "#050505"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#88a5b5",
      fillOpacity: 1
    },
    d: "M 244.230469 238.675781 L 226.699219 236.871094 C 225.785156 236.773438 225.121094 235.957031 225.214844 235.042969 L 227.019531 217.511719 C 227.113281 216.597656 227.933594 215.929688 228.847656 216.027344 L 246.378906 217.832031 C 247.292969 217.925781 247.960938 218.742188 247.863281 219.660156 L 246.058594 237.191406 C 245.964844 238.105469 245.144531 238.769531 244.230469 238.675781 Z M 244.230469 238.675781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 231.960938 226.140625 L 232.042969 225.34375 L 241.347656 226.300781 L 241.265625 227.097656 Z M 231.960938 226.140625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 231.59375 229.683594 L 231.675781 228.886719 L 240.984375 229.84375 L 240.902344 230.640625 Z M 231.59375 229.683594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 182.914062 232.625 L 136.578125 227.851562 C 135.480469 227.738281 134.679688 226.757812 134.792969 225.660156 L 136.585938 208.265625 C 136.699219 207.164062 137.683594 206.367188 138.78125 206.480469 L 185.117188 211.253906 C 186.214844 211.367188 187.015625 212.347656 186.902344 213.445312 L 185.109375 230.839844 C 184.996094 231.941406 184.011719 232.738281 182.914062 232.625 Z M 182.914062 232.625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 158.976562 218.941406 C 159.273438 216.074219 161.03125 214.613281 163.164062 214.832031 C 165.3125 215.054688 166.71875 216.84375 166.425781 219.707031 C 166.128906 222.574219 164.386719 224.039062 162.238281 223.816406 C 160.105469 223.597656 158.683594 221.808594 158.976562 218.941406 Z M 164.402344 219.5 C 164.605469 217.527344 163.996094 216.636719 162.988281 216.53125 C 161.996094 216.429688 161.21875 217.179688 161.015625 219.152344 C 160.8125 221.125 161.421875 222.015625 162.414062 222.117188 C 163.417969 222.222656 164.199219 221.472656 164.402344 219.5 Z M 164.402344 219.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 205.457031 228.84375 L 206.554688 219.550781 L 207.347656 219.644531 L 206.25 228.9375 Z M 205.457031 228.84375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 201.695312 224.164062 L 201.777344 223.371094 L 211.085938 224.328125 L 211.003906 225.125 Z M 201.695312 224.164062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 197.4375 76.988281 L 196.101562 89.976562 L 195.488281 89.914062 L 196.765625 77.5 L 193.5 77.164062 L 193.5625 76.589844 Z M 197.4375 76.988281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 208.109375 90.632812 L 208.046875 91.207031 L 199.253906 90.300781 L 199.300781 89.855469 L 205.445312 84.828125 C 207.203125 83.394531 207.636719 82.484375 207.746094 81.425781 C 207.921875 79.699219 206.832031 78.460938 204.566406 78.230469 C 202.84375 78.050781 201.527344 78.421875 200.511719 79.386719 L 200.125 78.933594 C 201.207031 77.921875 202.734375 77.457031 204.644531 77.65625 C 207.132812 77.910156 208.578125 79.355469 208.359375 81.449219 C 208.234375 82.675781 207.734375 83.710938 205.851562 85.242188 L 200.261719 89.824219 Z M 208.109375 90.632812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 218.402344 88.636719 C 218.179688 90.789062 216.5 92.152344 213.644531 91.859375 C 211.695312 91.660156 210.046875 90.738281 209.320312 89.59375 L 209.703125 89.183594 C 210.363281 90.207031 211.828125 91.089844 213.6875 91.28125 C 216.171875 91.539062 217.597656 90.445312 217.789062 88.574219 C 217.984375 86.679688 216.847656 85.34375 214.101562 85.0625 L 213.378906 84.988281 L 213.425781 84.542969 L 218.011719 79.6875 L 210.847656 78.953125 L 210.910156 78.375 L 218.886719 79.199219 L 218.839844 79.644531 L 214.234375 84.511719 C 217.273438 84.828125 218.625 86.464844 218.402344 88.636719 Z M 218.402344 88.636719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 231.179688 89.800781 L 228.359375 89.511719 L 227.972656 93.261719 L 227.363281 93.195312 L 227.746094 89.449219 L 220.289062 88.679688 L 220.335938 88.234375 L 228.421875 80.179688 L 229.144531 80.253906 L 221.164062 88.207031 L 227.804688 88.890625 L 228.144531 85.589844 L 228.757812 85.652344 L 228.417969 88.957031 L 231.238281 89.246094 Z M 231.179688 89.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 233.894531 93.308594 C 233.867188 93.546875 233.796875 93.691406 233.710938 93.980469 L 232.785156 96.398438 L 232.304688 96.347656 L 233.144531 93.847656 C 232.832031 93.761719 232.636719 93.496094 232.667969 93.179688 C 232.703125 92.847656 232.992188 92.59375 233.34375 92.632812 C 233.714844 92.671875 233.925781 93.011719 233.894531 93.308594 Z M 233.894531 93.308594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 246.765625 91.40625 L 243.945312 91.117188 L 243.558594 94.867188 L 242.945312 94.800781 L 243.332031 91.054688 L 235.871094 90.285156 L 235.917969 89.839844 L 244.003906 81.785156 L 244.730469 81.859375 L 236.746094 89.8125 L 243.390625 90.496094 L 243.730469 87.195312 L 244.339844 87.257812 L 244 90.558594 L 246.820312 90.851562 Z M 246.765625 91.40625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 256.402344 92.476562 C 256.1875 94.589844 254.550781 96.074219 251.601562 95.769531 C 249.691406 95.570312 248.023438 94.648438 247.296875 93.507812 L 247.695312 93.097656 C 248.339844 94.121094 249.824219 95.003906 251.660156 95.195312 C 254.203125 95.457031 255.582031 94.246094 255.773438 92.410156 C 255.980469 90.40625 254.914062 89.097656 251.203125 88.714844 L 248.679688 88.457031 L 249.996094 82.402344 L 256.695312 83.09375 L 256.636719 83.667969 L 250.457031 83.03125 L 249.386719 87.945312 L 251.390625 88.152344 C 255.363281 88.5625 256.640625 90.175781 256.402344 92.476562 Z M 256.402344 92.476562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 114.5 358.535156 L 109.410156 377.34375 L 125.941406 378.851562 L 129.417969 360.945312 Z M 114.5 358.535156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 126.421875 377.320312 C 126.417969 377.378906 125.492188 377.359375 124.003906 377.238281 C 122.511719 377.117188 120.460938 376.890625 118.203125 376.601562 C 116.027344 376.308594 114.058594 376.042969 112.425781 375.824219 C 110.949219 375.617188 110.035156 375.476562 110.039062 375.410156 C 110.046875 375.347656 110.972656 375.375 112.460938 375.5 C 113.949219 375.625 116 375.851562 118.261719 376.140625 C 120.4375 376.433594 122.40625 376.695312 124.039062 376.914062 C 125.515625 377.117188 126.429688 377.253906 126.421875 377.320312 Z M 126.421875 377.320312 "
  }), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface53",
    mask: "url(#mask16)",
    fill: "#050505"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 117.625 376.503906 C 117.519531 376.480469 118.222656 373.253906 119.195312 369.300781 C 120.167969 365.34375 121.042969 362.160156 121.144531 362.1875 C 121.25 362.210938 120.546875 365.4375 119.574219 369.390625 C 118.601562 373.347656 117.730469 376.53125 117.625 376.503906 Z M 117.625 376.503906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 125.507812 377.195312 C 125.410156 377.191406 126.035156 375.847656 125.546875 373.699219 C 125.296875 372.65625 124.746094 371.4375 123.738281 370.429688 C 122.746094 369.414062 121.257812 368.707031 119.625 368.539062 C 117.988281 368.378906 116.394531 368.777344 115.195312 369.542969 C 113.984375 370.304688 113.152344 371.339844 112.621094 372.277344 C 111.570312 374.207031 111.671875 375.65625 111.578125 375.632812 C 111.566406 375.632812 111.558594 375.546875 111.554688 375.382812 C 111.546875 375.21875 111.5625 374.976562 111.59375 374.667969 C 111.664062 374.050781 111.871094 373.152344 112.378906 372.148438 C 112.898438 371.160156 113.742188 370.058594 115.003906 369.242188 C 116.257812 368.414062 117.941406 367.984375 119.664062 368.152344 C 121.382812 368.328125 122.953125 369.085938 123.992188 370.175781 C 125.042969 371.257812 125.589844 372.546875 125.816406 373.640625 C 126.03125 374.75 125.957031 375.671875 125.820312 376.28125 C 125.75 376.585938 125.683594 376.820312 125.617188 376.96875 C 125.558594 377.125 125.523438 377.203125 125.507812 377.195312 Z M 125.507812 377.195312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 182.691406 356.394531 L 181.710938 371.203125 C 181.710938 371.203125 196.453125 376.097656 196.535156 378.851562 L 167.734375 379.058594 L 168.316406 355.921875 Z M 182.691406 356.394531 "
  }), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface56",
    mask: "url(#mask17)",
    fill: "#050505"
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface59",
    mask: "url(#mask18)",
    fill: "#050505"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 182.183594 371.074219 C 182.171875 371.214844 181.46875 371.257812 180.761719 371.6875 C 180.046875 372.097656 179.671875 372.695312 179.542969 372.636719 C 179.414062 372.605469 179.652344 371.773438 180.511719 371.265625 C 181.371094 370.75 182.21875 370.945312 182.183594 371.074219 Z M 182.183594 371.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 185.164062 372.414062 C 185.191406 372.550781 184.574219 372.769531 184.078125 373.351562 C 183.566406 373.914062 183.429688 374.554688 183.289062 374.542969 C 183.15625 374.5625 183.082031 373.738281 183.710938 373.027344 C 184.335938 372.3125 185.164062 372.277344 185.164062 372.414062 Z M 185.164062 372.414062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 186.769531 376.078125 C 186.640625 376.105469 186.464844 375.394531 186.851562 374.636719 C 187.230469 373.875 187.902344 373.589844 187.957031 373.710938 C 188.03125 373.828125 187.59375 374.230469 187.289062 374.855469 C 186.96875 375.476562 186.910156 376.066406 186.769531 376.078125 Z M 186.769531 376.078125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 182.03125 367.671875 C 181.96875 367.800781 181.328125 367.585938 180.535156 367.613281 C 179.738281 367.628906 179.109375 367.875 179.039062 367.753906 C 178.960938 367.652344 179.582031 367.148438 180.519531 367.125 C 181.457031 367.097656 182.105469 367.5625 182.03125 367.671875 Z M 182.03125 367.671875 "
  }), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface62",
    mask: "url(#mask19)",
    fill: "#050505"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 182.175781 364.679688 C 182.175781 364.738281 181.617188 364.808594 180.734375 364.628906 C 180.292969 364.539062 179.777344 364.378906 179.238281 364.121094 C 178.96875 363.992188 178.695312 363.835938 178.425781 363.65625 C 178.292969 363.566406 178.140625 363.476562 178 363.304688 C 177.847656 363.152344 177.769531 362.777344 177.957031 362.554688 C 178.113281 362.339844 178.375 362.25 178.582031 362.253906 C 178.796875 362.253906 178.964844 362.300781 179.121094 362.34375 C 179.441406 362.429688 179.738281 362.546875 180.007812 362.679688 C 180.550781 362.945312 180.988281 363.273438 181.3125 363.589844 C 181.960938 364.230469 182.171875 364.761719 182.125 364.789062 C 182.058594 364.832031 181.746094 364.382812 181.082031 363.851562 C 180.753906 363.585938 180.328125 363.308594 179.820312 363.085938 C 179.566406 362.976562 179.289062 362.878906 179 362.808594 C 178.695312 362.71875 178.4375 362.707031 178.355469 362.839844 C 178.324219 362.890625 178.320312 362.910156 178.382812 363.003906 C 178.445312 363.085938 178.566406 363.171875 178.695312 363.261719 C 178.945312 363.433594 179.195312 363.585938 179.441406 363.71875 C 179.9375 363.984375 180.414062 364.167969 180.820312 364.296875 C 181.636719 364.550781 182.179688 364.605469 182.175781 364.679688 Z M 182.175781 364.679688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 181.984375 364.875 C 181.933594 364.898438 181.671875 364.386719 181.644531 363.472656 C 181.636719 363.019531 181.699219 362.476562 181.890625 361.902344 C 181.988281 361.613281 182.117188 361.324219 182.285156 361.035156 C 182.460938 360.757812 182.679688 360.382812 183.226562 360.335938 C 183.511719 360.335938 183.742188 360.5625 183.816406 360.757812 C 183.90625 360.953125 183.917969 361.121094 183.945312 361.289062 C 183.992188 361.628906 183.972656 361.957031 183.917969 362.261719 C 183.808594 362.871094 183.542969 363.371094 183.257812 363.730469 C 182.671875 364.460938 182.082031 364.609375 182.070312 364.5625 C 182.027344 364.492188 182.523438 364.234375 182.976562 363.53125 C 183.199219 363.183594 183.402344 362.722656 183.472656 362.191406 C 183.507812 361.925781 183.511719 361.640625 183.472656 361.355469 C 183.433594 361.046875 183.328125 360.796875 183.210938 360.828125 C 183.070312 360.820312 182.820312 361.042969 182.695312 361.28125 C 182.539062 361.535156 182.414062 361.796875 182.3125 362.054688 C 182.117188 362.566406 182.023438 363.0625 181.992188 363.484375 C 181.929688 364.328125 182.0625 364.859375 181.984375 364.875 Z M 181.984375 364.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#88a5b5",
      fillOpacity: 1
    },
    d: "M 120.246094 125.714844 C 120.246094 125.714844 117.125 142.753906 114.613281 153.066406 C 112.667969 161.074219 107.621094 176.085938 116.75 180.445312 C 125.878906 184.804688 138.15625 167.210938 138.15625 167.210938 L 143.363281 127.105469 C 139.734375 127.785156 135.628906 131.988281 131.25 138.171875 L 132.046875 122.960938 Z M 120.246094 125.714844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,74.509804%,61.568627%)",
      fillOpacity: 1
    },
    d: "M 245.863281 150.886719 L 241.058594 153.175781 L 236.640625 146.242188 L 239.226562 140.890625 C 239.46875 140.394531 239.734375 139.835938 240.007812 139.195312 C 240.328125 138.449219 240.519531 137.652344 240.578125 136.84375 C 240.648438 135.859375 240.691406 134.554688 240.5 133.832031 C 240.261719 132.9375 241.207031 132.207031 241.847656 132.726562 C 242.492188 133.246094 243.207031 135.691406 242.730469 138.640625 C 242.253906 141.589844 245.6875 138.460938 246.960938 137.34375 C 248.230469 136.226562 252.320312 132.957031 252.964844 133.085938 C 253.90625 133.273438 253.878906 134.34375 252.585938 135.429688 C 251.273438 136.527344 247.628906 140.046875 248.234375 140.703125 C 248.234375 140.703125 248.242188 140.707031 248.261719 140.707031 C 249.796875 140.867188 251.058594 142.003906 251.394531 143.507812 C 251.722656 144.960938 251.988281 146.96875 251.167969 147.628906 C 249.632812 148.875 245.863281 150.886719 245.863281 150.886719 Z M 245.863281 150.886719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,74.509804%,61.568627%)",
      fillOpacity: 1
    },
    d: "M 152.789062 86.226562 L 152.660156 127.917969 L 170.546875 128.769531 L 171.0625 118.628906 C 171.0625 118.628906 177.414062 119.890625 179.054688 113.992188 C 180.101562 110.222656 179.839844 81.097656 179.839844 81.097656 Z M 152.789062 86.226562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 183.878906 85.207031 C 182.675781 87.699219 176.9375 92.257812 176.9375 92.257812 L 174.347656 99.203125 C 172.09375 97.441406 169.074219 97.542969 168.5 101.496094 C 168.085938 104.355469 171.640625 104.933594 171.640625 104.933594 C 169.574219 108.457031 168.167969 111.304688 165.15625 114.652344 C 161.894531 118.277344 160.070312 118.640625 156.535156 118.699219 L 152.632812 118.699219 C 152.632812 118.699219 144.65625 112.035156 146.234375 94.472656 C 147.808594 76.914062 163.597656 82.035156 167.363281 77.648438 C 173.5 70.503906 187.898438 76.894531 183.878906 85.207031 Z M 183.878906 85.207031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#88a5b5",
      fillOpacity: 1
    },
    d: "M 147.121094 109.15625 C 147.121094 109.15625 147.292969 109.152344 147.617188 109.15625 C 147.945312 109.140625 148.429688 109.128906 149.035156 108.992188 C 150.242188 108.753906 151.957031 108.046875 153.617188 106.566406 C 155.292969 105.105469 156.769531 102.878906 158.261719 100.351562 C 159.019531 99.09375 159.808594 97.761719 160.769531 96.472656 C 161.726562 95.191406 162.859375 93.9375 164.277344 92.976562 C 165.695312 92.007812 167.292969 91.4375 168.839844 91.035156 C 170.394531 90.628906 171.921875 90.378906 173.359375 90.101562 C 176.238281 89.570312 178.820312 88.769531 180.582031 87.402344 C 182.347656 86.050781 183.230469 84.371094 183.507812 83.175781 C 183.664062 82.574219 183.664062 82.089844 183.679688 81.765625 C 183.660156 81.441406 183.660156 81.265625 183.660156 81.265625 C 183.660156 81.265625 183.683594 81.4375 183.710938 81.765625 C 183.707031 82.089844 183.71875 82.582031 183.570312 83.191406 C 183.308594 84.402344 182.433594 86.113281 180.65625 87.496094 C 178.878906 88.890625 176.269531 89.710938 173.390625 90.25 C 171.945312 90.535156 170.425781 90.789062 168.878906 91.191406 C 167.34375 91.597656 165.765625 92.160156 164.371094 93.113281 C 162.972656 94.058594 161.855469 95.300781 160.898438 96.570312 C 159.945312 97.851562 159.152344 99.175781 158.394531 100.429688 C 156.894531 102.953125 155.398438 105.191406 153.695312 106.65625 C 152.007812 108.136719 150.269531 108.832031 149.046875 109.054688 C 148.433594 109.179688 147.945312 109.183594 147.621094 109.1875 C 147.289062 109.171875 147.121094 109.15625 147.121094 109.15625 Z M 147.121094 109.15625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#88a5b5",
      fillOpacity: 1
    },
    d: "M 146.199219 94.875 C 146.199219 94.875 146.480469 94.765625 147.027344 94.582031 C 147.574219 94.40625 148.386719 94.128906 149.476562 94 C 150.546875 93.878906 152 93.925781 153.3125 94.828125 C 153.953125 95.269531 154.53125 95.976562 154.683594 96.871094 C 154.835938 97.738281 154.644531 98.792969 153.894531 99.484375 C 153.523438 99.828125 153.015625 100.023438 152.492188 100.046875 C 151.964844 100.074219 151.4375 99.902344 150.964844 99.640625 C 150.027344 99.097656 149.269531 98.164062 148.921875 97.050781 C 148.546875 95.949219 148.480469 94.703125 148.765625 93.496094 C 149.042969 92.292969 149.707031 91.132812 150.691406 90.265625 C 151.664062 89.394531 152.933594 88.792969 154.300781 88.652344 C 155.671875 88.507812 157.058594 88.808594 158.410156 89.183594 C 159.765625 89.566406 161.128906 90.003906 162.566406 90.179688 C 164 90.375 165.480469 90.382812 166.953125 90.191406 C 168.417969 89.988281 169.867188 89.640625 171.167969 89.027344 C 172.453125 88.417969 173.621094 87.414062 173.996094 86.0625 C 174.367188 84.742188 174.015625 83.234375 173.054688 82.3125 C 172.101562 81.375 170.578125 81.25 169.441406 81.777344 C 168.871094 82.039062 168.378906 82.476562 168.109375 83.027344 C 167.824219 83.574219 167.75 84.203125 167.824219 84.796875 C 167.980469 85.988281 168.695312 87.050781 169.644531 87.660156 C 170.597656 88.28125 171.714844 88.515625 172.769531 88.539062 C 173.832031 88.566406 174.84375 88.375 175.769531 88.089844 C 177.632812 87.515625 179.121094 86.472656 180.210938 85.382812 C 181.316406 84.296875 182.03125 83.148438 182.503906 82.167969 C 182.992188 81.1875 183.1875 80.355469 183.34375 79.804688 C 183.453125 79.242188 183.519531 78.945312 183.519531 78.945312 C 183.519531 78.945312 183.472656 79.246094 183.375 79.8125 C 183.230469 80.367188 183.042969 81.207031 182.5625 82.195312 C 182.097656 83.183594 181.382812 84.347656 180.273438 85.449219 C 179.183594 86.550781 177.6875 87.613281 175.804688 88.199219 C 174.871094 88.492188 173.84375 88.691406 172.765625 88.667969 C 171.695312 88.644531 170.554688 88.410156 169.566406 87.773438 C 168.585938 87.148438 167.84375 86.054688 167.675781 84.8125 C 167.601562 84.195312 167.675781 83.535156 167.976562 82.960938 C 168.261719 82.375 168.78125 81.914062 169.378906 81.640625 C 170.566406 81.085938 172.152344 81.210938 173.167969 82.199219 C 174.171875 83.167969 174.539062 84.726562 174.152344 86.109375 C 173.761719 87.523438 172.546875 88.554688 171.242188 89.175781 C 169.914062 89.804688 168.457031 90.152344 166.972656 90.359375 C 165.488281 90.550781 163.992188 90.539062 162.546875 90.347656 C 161.09375 90.164062 159.714844 89.722656 158.367188 89.34375 C 157.023438 88.964844 155.652344 88.671875 154.316406 88.8125 C 152.984375 88.945312 151.742188 89.53125 150.792969 90.382812 C 148.832031 92.082031 148.316406 94.871094 149.050781 97.007812 C 149.386719 98.09375 150.121094 99 151.027344 99.527344 C 151.480469 99.78125 151.988281 99.949219 152.488281 99.925781 C 152.980469 99.902344 153.464844 99.722656 153.816406 99.398438 C 154.527344 98.746094 154.726562 97.730469 154.578125 96.890625 C 154.433594 96.03125 153.882812 95.34375 153.261719 94.90625 C 151.976562 94.015625 150.546875 93.953125 149.484375 94.0625 C 148.398438 94.179688 147.585938 94.449219 147.035156 94.613281 C 146.488281 94.785156 146.199219 94.875 146.199219 94.875 Z M 146.199219 94.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 134.410156 208.363281 L 110.597656 364.742188 L 130.375 367.25 L 158.277344 236.085938 L 165.300781 368.132812 L 186.734375 367.757812 L 183.179688 208.726562 Z M 134.410156 208.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 164.921875 368.539062 L 164.902344 368.152344 L 158.035156 239.128906 L 130.6875 367.695312 L 110.140625 365.085938 L 134.066406 207.957031 L 183.570312 208.332031 L 187.140625 368.152344 Z M 158.515625 233.039062 L 165.679688 367.726562 L 186.324219 367.363281 L 182.789062 209.125 L 134.753906 208.761719 L 111.058594 364.394531 L 130.058594 366.808594 Z M 158.515625 233.039062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#88a5b5",
      fillOpacity: 1
    },
    d: "M 180.367188 367.507812 C 180.25 367.507812 180.15625 336.175781 180.15625 297.53125 C 180.15625 258.878906 180.25 227.550781 180.367188 227.550781 C 180.480469 227.550781 180.574219 258.875 180.574219 297.53125 C 180.574219 336.175781 180.480469 367.507812 180.367188 367.507812 Z M 180.367188 367.507812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#88a5b5",
      fillOpacity: 1
    },
    d: "M 126.023438 366.9375 C 126.015625 366.9375 126.03125 366.820312 126.070312 366.597656 C 126.113281 366.355469 126.175781 366.027344 126.253906 365.605469 C 126.425781 364.71875 126.671875 363.441406 126.988281 361.804688 C 127.652344 358.488281 128.609375 353.726562 129.792969 347.847656 C 132.191406 336.066406 135.59375 319.8125 139.496094 301.890625 C 143.40625 283.960938 147.074219 267.765625 149.792969 256.054688 C 151.164062 250.21875 152.277344 245.488281 153.050781 242.195312 C 153.441406 240.578125 153.75 239.3125 153.964844 238.433594 C 154.066406 238.019531 154.152344 237.695312 154.210938 237.457031 C 154.269531 237.238281 154.300781 237.125 154.308594 237.128906 C 154.316406 237.128906 154.296875 237.242188 154.253906 237.464844 C 154.203125 237.707031 154.132812 238.035156 154.042969 238.453125 C 153.847656 239.335938 153.566406 240.605469 153.207031 242.230469 C 152.464844 245.53125 151.398438 250.269531 150.078125 256.121094 C 147.4375 267.84375 143.8125 284.054688 139.90625 301.980469 C 136 319.898438 132.554688 336.144531 130.078125 347.90625 C 128.84375 353.773438 127.84375 358.527344 127.144531 361.839844 C 126.796875 363.464844 126.523438 364.738281 126.335938 365.625 C 126.242188 366.039062 126.167969 366.367188 126.113281 366.605469 C 126.0625 366.828125 126.03125 366.9375 126.023438 366.9375 Z M 126.023438 366.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#88a5b5",
      fillOpacity: 1
    },
    d: "M 165.300781 235.945312 C 165.304688 235.972656 164.980469 236.015625 164.398438 236.066406 C 163.726562 236.113281 162.898438 236.171875 161.925781 236.238281 C 159.839844 236.378906 156.957031 236.523438 153.785156 236.832031 C 150.617188 237.148438 147.761719 237.574219 145.6875 237.84375 C 144.71875 237.96875 143.898438 238.070312 143.230469 238.15625 C 142.648438 238.222656 142.324219 238.246094 142.320312 238.21875 C 142.3125 238.1875 142.628906 238.109375 143.203125 237.996094 C 143.777344 237.882812 144.609375 237.730469 145.640625 237.554688 C 147.703125 237.207031 150.5625 236.734375 153.746094 236.417969 C 156.929688 236.105469 159.824219 236.011719 161.914062 235.945312 C 162.957031 235.917969 163.804688 235.902344 164.390625 235.902344 C 164.976562 235.902344 165.300781 235.917969 165.300781 235.945312 Z M 165.300781 235.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#88a5b5",
      fillOpacity: 1
    },
    d: "M 183.597656 225.789062 C 183.601562 225.816406 183.382812 225.878906 182.980469 225.945312 C 182.578125 226.011719 181.988281 226.058594 181.253906 226.023438 C 179.800781 225.964844 177.746094 225.472656 175.90625 224.152344 C 174.066406 222.828125 172.945312 221.035156 172.425781 219.675781 C 172.160156 218.996094 172.015625 218.417969 171.949219 218.015625 C 171.882812 217.613281 171.875 217.390625 171.902344 217.386719 C 171.972656 217.367188 172.109375 218.261719 172.699219 219.5625 C 173.273438 220.855469 174.386719 222.546875 176.148438 223.8125 C 177.910156 225.078125 179.871094 225.597656 181.277344 225.730469 C 182.699219 225.871094 183.585938 225.714844 183.597656 225.789062 Z M 183.597656 225.789062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#88a5b5",
      fillOpacity: 1
    },
    d: "M 130.335938 211.429688 L 185.117188 211.253906 L 182.121094 175.101562 C 181.789062 166.828125 181.839844 165.84375 181.632812 158.207031 C 181.632812 158.207031 189.410156 167.609375 195.527344 174.203125 C 199.222656 178.1875 205.078125 179.300781 209.992188 176.976562 L 241.996094 154.648438 L 236.003906 139.316406 L 206.917969 157.121094 C 205.585938 156.292969 194.261719 140.140625 186.4375 132.253906 C 181.429688 127.203125 174.675781 124.300781 167.570312 124.09375 C 162.191406 123.933594 155.695312 124.183594 149.898438 124.800781 C 141.085938 125.738281 134.1875 132.816406 133.449219 141.652344 C 132.882812 148.410156 133.335938 156.257812 133.335938 169.597656 Z M 130.335938 211.429688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 132.914062 145.304688 C 132.914062 145.304688 132.921875 145.453125 132.921875 145.730469 C 132.921875 146.054688 132.917969 146.453125 132.914062 146.9375 C 132.898438 147.992188 132.898438 149.511719 132.910156 151.390625 C 132.933594 155.148438 133.085938 160.335938 133.246094 166.070312 C 133.40625 171.804688 133.4375 177.003906 133.292969 180.761719 C 133.230469 182.640625 133.144531 184.160156 133.058594 185.207031 C 133.019531 185.695312 132.984375 186.09375 132.957031 186.414062 C 132.933594 186.691406 132.914062 186.835938 132.914062 186.835938 C 132.914062 186.835938 132.910156 186.691406 132.925781 186.414062 C 132.941406 186.089844 132.964844 185.691406 132.992188 185.203125 C 133.0625 184.15625 133.125 182.636719 133.175781 180.757812 C 133.289062 177.003906 133.242188 171.808594 133.078125 166.074219 C 132.917969 160.34375 132.785156 155.152344 132.792969 151.390625 C 132.796875 149.511719 132.8125 147.988281 132.847656 146.9375 C 132.863281 146.453125 132.878906 146.050781 132.886719 145.726562 C 132.898438 145.453125 132.914062 145.304688 132.914062 145.304688 Z M 132.914062 145.304688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 205.71875 162.292969 C 205.699219 162.289062 205.742188 162.003906 205.835938 161.539062 C 205.925781 161.078125 206.066406 160.441406 206.230469 159.742188 C 206.394531 159.042969 206.550781 158.410156 206.671875 157.957031 C 206.792969 157.5 206.878906 157.222656 206.902344 157.230469 C 206.925781 157.234375 206.878906 157.523438 206.785156 157.988281 C 206.695312 158.449219 206.554688 159.082031 206.394531 159.78125 C 206.230469 160.480469 206.074219 161.109375 205.953125 161.5625 C 205.828125 162.019531 205.742188 162.300781 205.71875 162.292969 Z M 205.71875 162.292969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 208.636719 162.742188 C 208.589844 162.753906 208.257812 161.464844 207.894531 159.863281 C 207.527344 158.261719 207.269531 156.953125 207.3125 156.945312 C 207.359375 156.933594 207.691406 158.222656 208.054688 159.824219 C 208.421875 161.425781 208.679688 162.734375 208.636719 162.742188 Z M 208.636719 162.742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 182.984375 159.5625 C 182.984375 159.5625 182.878906 159.472656 182.683594 159.289062 C 182.460938 159.066406 182.183594 158.800781 181.847656 158.476562 C 181.128906 157.765625 180.085938 156.738281 178.84375 155.417969 C 177.605469 154.097656 176.164062 152.488281 174.757812 150.546875 C 173.355469 148.605469 171.988281 146.320312 171.039062 143.710938 C 170.078125 141.113281 169.667969 138.449219 169.816406 136.046875 C 169.925781 133.65625 170.378906 131.496094 171.195312 129.863281 C 171.992188 128.21875 173.078125 127.15625 173.886719 126.550781 C 174.296875 126.253906 174.621094 126.035156 174.859375 125.910156 C 175.089844 125.777344 175.214844 125.714844 175.214844 125.714844 C 175.230469 125.742188 174.722656 125.984375 173.925781 126.601562 C 173.136719 127.21875 172.074219 128.28125 171.300781 129.914062 C 170.507812 131.535156 170.070312 133.675781 169.96875 136.054688 C 169.832031 138.4375 170.242188 141.074219 171.195312 143.65625 C 172.136719 146.242188 173.492188 148.519531 174.878906 150.457031 C 176.273438 152.394531 177.703125 154.007812 178.929688 155.339844 C 180.15625 156.664062 181.1875 157.707031 181.894531 158.429688 C 182.21875 158.761719 182.488281 159.039062 182.707031 159.261719 C 182.894531 159.453125 182.984375 159.5625 182.984375 159.5625 Z M 182.984375 159.5625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 147.375 144.6875 C 147.285156 144.757812 146.445312 143.847656 145.496094 142.652344 C 144.546875 141.457031 143.851562 140.429688 143.941406 140.355469 C 144.035156 140.285156 144.875 141.195312 145.824219 142.394531 C 146.769531 143.589844 147.464844 144.613281 147.375 144.6875 Z M 147.375 144.6875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 159.828125 158.816406 C 159.90625 158.898438 158.746094 160.1875 157.230469 161.699219 C 155.71875 163.210938 154.421875 164.371094 154.339844 164.289062 C 154.261719 164.207031 155.421875 162.914062 156.9375 161.402344 C 158.453125 159.894531 159.746094 158.734375 159.828125 158.816406 Z M 159.828125 158.816406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 171.875 179.09375 C 171.757812 179.128906 171.316406 177.890625 170.503906 176.515625 C 169.703125 175.128906 168.839844 174.140625 168.929688 174.058594 C 169 173.976562 170.03125 174.867188 170.863281 176.304688 C 171.707031 177.734375 171.980469 179.070312 171.875 179.09375 Z M 171.875 179.09375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 140.640625 176.796875 C 140.542969 176.839844 139.757812 175.097656 139.355469 172.792969 C 138.945312 170.488281 139.09375 168.582031 139.199219 168.589844 C 139.324219 168.589844 139.363281 170.460938 139.765625 172.71875 C 140.15625 174.980469 140.757812 176.753906 140.640625 176.796875 Z M 140.640625 176.796875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 157.226562 185.726562 C 157.128906 185.769531 156.488281 184.296875 156.320312 182.347656 C 156.140625 180.402344 156.507812 178.839844 156.613281 178.867188 C 156.734375 178.882812 156.558594 180.425781 156.734375 182.3125 C 156.898438 184.199219 157.34375 185.6875 157.226562 185.726562 Z M 157.226562 185.726562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 150.667969 198.699219 C 150.605469 198.796875 148.921875 197.855469 146.90625 196.59375 C 144.886719 195.332031 143.300781 194.230469 143.363281 194.132812 C 143.425781 194.035156 145.109375 194.976562 147.125 196.238281 C 149.140625 197.5 150.726562 198.601562 150.667969 198.699219 Z M 150.667969 198.699219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 176.457031 194.863281 C 176.507812 194.972656 174.652344 195.894531 172.5 197.257812 C 170.34375 198.613281 168.710938 199.890625 168.632812 199.796875 C 168.5625 199.71875 170.09375 198.28125 172.277344 196.90625 C 174.460938 195.523438 176.417969 194.761719 176.457031 194.863281 Z M 176.457031 194.863281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 144.019531 209.527344 C 143.996094 209.636719 142.191406 209.371094 139.984375 208.933594 C 137.777344 208.492188 136.007812 208.042969 136.03125 207.929688 C 136.050781 207.820312 137.859375 208.085938 140.066406 208.523438 C 142.269531 208.964844 144.042969 209.414062 144.019531 209.527344 Z M 144.019531 209.527344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 161.308594 206.710938 C 161.230469 206.78125 160.238281 205.746094 159.40625 204.199219 C 158.566406 202.65625 158.238281 201.261719 158.339844 201.230469 C 158.457031 201.195312 158.953125 202.5 159.769531 204 C 160.582031 205.503906 161.40625 206.632812 161.308594 206.710938 Z M 161.308594 206.710938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 180.765625 208.066406 C 180.855469 208.140625 180.296875 208.953125 179.523438 209.882812 C 178.746094 210.808594 178.042969 211.503906 177.957031 211.429688 C 177.867188 211.355469 178.425781 210.542969 179.203125 209.613281 C 179.976562 208.683594 180.679688 207.992188 180.765625 208.066406 Z M 180.765625 208.066406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 145.175781 153.070312 C 145.242188 153.167969 144.527344 153.757812 143.582031 154.386719 C 142.636719 155.019531 141.820312 155.453125 141.753906 155.355469 C 141.691406 155.261719 142.40625 154.671875 143.351562 154.039062 C 144.296875 153.410156 145.113281 152.976562 145.175781 153.070312 Z M 145.175781 153.070312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 158.679688 137.992188 C 158.574219 138.027344 157.863281 136.203125 157.238281 133.875 C 156.613281 131.546875 156.316406 129.613281 156.429688 129.589844 C 156.542969 129.566406 157.019531 131.453125 157.640625 133.765625 C 158.261719 136.082031 158.792969 137.953125 158.679688 137.992188 Z M 158.679688 137.992188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 171.644531 151.722656 C 171.59375 151.832031 170.425781 151.382812 168.925781 151.101562 C 167.429688 150.808594 166.175781 150.796875 166.171875 150.671875 C 166.160156 150.566406 167.449219 150.390625 169.003906 150.691406 C 170.5625 150.988281 171.695312 151.625 171.644531 151.722656 Z M 171.644531 151.722656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 180.558594 140.058594 C 180.574219 140.164062 179.195312 140.421875 177.503906 140.15625 C 175.808594 139.902344 174.574219 139.238281 174.621094 139.144531 C 174.667969 139.03125 175.9375 139.5 177.566406 139.746094 C 179.195312 140 180.546875 139.933594 180.558594 140.058594 Z M 180.558594 140.058594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 189.675781 153.066406 C 189.566406 153.066406 189.5 151.074219 189.898438 148.65625 C 190.285156 146.234375 190.976562 144.363281 191.078125 144.398438 C 191.195312 144.433594 190.691406 146.335938 190.308594 148.722656 C 189.917969 151.105469 189.796875 153.070312 189.675781 153.066406 Z M 189.675781 153.066406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 200.390625 168.386719 C 200.304688 168.46875 199.03125 167.289062 197.542969 165.753906 C 196.054688 164.214844 194.914062 162.90625 194.996094 162.824219 C 195.078125 162.746094 196.351562 163.925781 197.84375 165.460938 C 199.332031 167 200.472656 168.308594 200.390625 168.386719 Z M 200.390625 168.386719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 209.304688 167.210938 C 209.402344 167.273438 208.757812 168.445312 207.867188 169.828125 C 206.976562 171.207031 206.175781 172.277344 206.082031 172.214844 C 205.984375 172.152344 206.628906 170.980469 207.519531 169.601562 C 208.410156 168.21875 209.207031 167.148438 209.304688 167.210938 Z M 209.304688 167.210938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 219.644531 162.171875 C 219.542969 162.222656 218.769531 160.84375 217.917969 159.09375 C 217.070312 157.34375 216.464844 155.882812 216.570312 155.832031 C 216.671875 155.78125 217.445312 157.160156 218.292969 158.910156 C 219.144531 160.660156 219.75 162.121094 219.644531 162.171875 Z M 219.644531 162.171875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 233.730469 156.34375 C 233.707031 156.460938 232.0625 156.261719 230.054688 155.902344 C 228.042969 155.546875 226.429688 155.164062 226.453125 155.050781 C 226.472656 154.9375 228.117188 155.136719 230.125 155.496094 C 232.136719 155.851562 233.75 156.230469 233.730469 156.34375 Z M 233.730469 156.34375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 121.882812 171.324219 C 121.78125 171.277344 122.445312 169.644531 123.371094 167.679688 C 124.292969 165.71875 125.128906 164.164062 125.234375 164.214844 C 125.335938 164.261719 124.671875 165.894531 123.746094 167.859375 C 122.824219 169.820312 121.988281 171.375 121.882812 171.324219 Z M 121.882812 171.324219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 129.347656 158.15625 C 129.261719 158.234375 128.179688 157.167969 126.925781 155.773438 C 125.671875 154.378906 124.726562 153.1875 124.8125 153.109375 C 124.898438 153.035156 125.980469 154.101562 127.234375 155.496094 C 128.488281 156.890625 129.433594 158.082031 129.347656 158.15625 Z M 129.347656 158.15625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 128.730469 179.304688 C 128.804688 179.394531 128.25 179.976562 127.492188 180.605469 C 126.734375 181.234375 126.0625 181.675781 125.988281 181.585938 C 125.914062 181.496094 126.46875 180.914062 127.226562 180.285156 C 127.984375 179.65625 128.65625 179.21875 128.730469 179.304688 Z M 128.730469 179.304688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 131.25 144.164062 C 131.339844 144.238281 131.003906 144.804688 130.5 145.4375 C 129.996094 146.066406 129.515625 146.519531 129.425781 146.449219 C 129.335938 146.375 129.671875 145.808594 130.175781 145.175781 C 130.679688 144.546875 131.160156 144.09375 131.25 144.164062 Z M 131.25 144.164062 "
  }), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface65",
    mask: "url(#mask20)",
    fill: "#050505"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 118.015625 161.714844 C 118.007812 161.710938 118.046875 161.621094 118.117188 161.453125 C 118.210938 161.238281 118.320312 160.996094 118.445312 160.714844 C 118.726562 160.078125 119.15625 159.160156 119.699219 158.03125 C 120.78125 155.777344 122.355469 152.695312 124.238281 149.371094 C 126.121094 146.046875 127.957031 143.113281 129.335938 141.023438 C 130.023438 139.980469 130.589844 139.140625 130.992188 138.570312 C 131.167969 138.320312 131.324219 138.101562 131.457031 137.910156 C 131.566406 137.761719 131.625 137.683594 131.628906 137.6875 C 131.632812 137.691406 131.585938 137.773438 131.484375 137.929688 C 131.359375 138.125 131.210938 138.347656 131.046875 138.605469 C 130.621094 139.257812 130.078125 140.09375 129.433594 141.089844 C 128.082031 143.191406 126.265625 146.132812 124.382812 149.453125 C 122.503906 152.773438 120.914062 155.839844 119.804688 158.082031 C 119.285156 159.148438 118.847656 160.042969 118.503906 160.742188 C 118.371094 161.019531 118.253906 161.257812 118.152344 161.46875 C 118.066406 161.632812 118.019531 161.714844 118.015625 161.714844 Z M 118.015625 161.714844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 123.410156 151.53125 C 123.421875 151.558594 123.074219 151.671875 122.539062 151.898438 C 122.003906 152.128906 121.28125 152.492188 120.550781 153 C 119.824219 153.507812 119.230469 154.058594 118.828125 154.480469 C 118.425781 154.902344 118.203125 155.1875 118.179688 155.171875 C 118.171875 155.164062 118.21875 155.085938 118.3125 154.953125 C 118.402344 154.8125 118.550781 154.625 118.742188 154.402344 C 119.125 153.953125 119.714844 153.378906 120.457031 152.863281 C 121.199219 152.347656 121.941406 151.996094 122.496094 151.792969 C 122.769531 151.691406 123 151.617188 123.160156 151.578125 C 123.320312 151.539062 123.410156 151.519531 123.410156 151.53125 Z M 123.410156 151.53125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 124.164062 135.121094 C 124.257812 135.1875 123.167969 136.855469 121.734375 138.839844 C 120.296875 140.828125 119.054688 142.382812 118.960938 142.3125 C 118.867188 142.246094 119.957031 140.582031 121.394531 138.597656 C 122.832031 136.609375 124.070312 135.054688 124.164062 135.121094 Z M 124.164062 135.121094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,74.509804%,61.568627%)",
      fillOpacity: 1
    },
    d: "M 129.941406 122.109375 C 130.707031 122.351562 131.527344 121.816406 131.972656 121.148438 C 132.421875 120.480469 132.628906 119.679688 133.023438 118.976562 C 134.214844 116.886719 136.917969 115.976562 138.003906 113.832031 C 138.15625 113.53125 138.25 113.113281 137.988281 112.902344 C 137.75 112.707031 137.390625 112.839844 137.113281 112.980469 C 134.738281 114.167969 132.363281 115.359375 129.988281 116.546875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.156863%,60%,43.137255%)",
      fillOpacity: 1
    },
    d: "M 129.988281 116.546875 C 129.972656 116.519531 130.234375 116.355469 130.71875 116.082031 C 131.203125 115.808594 131.910156 115.429688 132.789062 114.964844 C 133.707031 114.492188 134.746094 113.949219 135.882812 113.363281 C 136.175781 113.210938 136.476562 113.058594 136.78125 112.902344 C 137.078125 112.78125 137.40625 112.488281 137.941406 112.625 C 138.207031 112.707031 138.378906 113.003906 138.378906 113.242188 C 138.386719 113.480469 138.320312 113.6875 138.234375 113.878906 C 138.054688 114.230469 137.847656 114.558594 137.59375 114.863281 C 136.578125 116.074219 135.300781 116.8125 134.363281 117.691406 C 133.886719 118.121094 133.484375 118.574219 133.199219 119.058594 C 132.914062 119.542969 132.726562 120.054688 132.503906 120.507812 C 132.101562 121.445312 131.386719 122.046875 130.816406 122.179688 C 130.234375 122.328125 129.925781 122.121094 129.941406 122.109375 C 129.949219 122.066406 130.261719 122.195312 130.761719 122.011719 C 131.265625 121.832031 131.859375 121.285156 132.210938 120.375 C 132.410156 119.929688 132.578125 119.40625 132.871094 118.871094 C 133.164062 118.339844 133.589844 117.839844 134.074219 117.382812 C 135.039062 116.457031 136.304688 115.699219 137.238281 114.574219 C 137.476562 114.296875 137.664062 113.988281 137.824219 113.6875 C 137.96875 113.390625 137.964844 113.082031 137.789062 113.042969 C 137.605469 112.972656 137.277344 113.136719 136.972656 113.292969 C 136.667969 113.441406 136.367188 113.589844 136.070312 113.734375 C 134.917969 114.292969 133.863281 114.804688 132.933594 115.253906 C 132.035156 115.679688 131.304688 116.015625 130.796875 116.242188 C 130.289062 116.464844 130.003906 116.574219 129.988281 116.546875 Z M 129.988281 116.546875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 302.644531 336.308594 L 353.28125 336.308594 L 353.28125 343.265625 L 302.644531 343.265625 Z M 302.644531 336.308594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 353.367188 343.351562 L 302.558594 343.351562 L 302.558594 336.222656 L 353.367188 336.222656 Z M 302.734375 343.179688 L 353.195312 343.179688 L 353.195312 336.394531 L 302.734375 336.394531 Z M 302.734375 343.179688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 307.339844 340.949219 L 314.628906 376.90625 L 341.597656 376.90625 L 348.644531 343.265625 Z M 307.339844 340.949219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#88a5b5",
      fillOpacity: 1
    },
    d: "M 307.339844 373.507812 L 311.230469 378.851562 L 344.007812 378.851562 L 348.644531 373.507812 Z M 307.339844 373.507812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 326.0625 342 C 325.964844 342 325.835938 325.34375 325.777344 304.796875 C 325.71875 284.246094 325.753906 267.59375 325.855469 267.59375 C 325.953125 267.59375 326.082031 284.246094 326.136719 304.796875 C 326.195312 325.339844 326.164062 342 326.0625 342 Z M 326.0625 342 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 337.34375 300.3125 C 337.355469 300.320312 337.304688 300.453125 337.207031 300.699219 C 337.089844 300.984375 336.9375 301.339844 336.753906 301.777344 C 336.652344 302.015625 336.542969 302.273438 336.425781 302.554688 C 336.320312 302.847656 336.207031 303.164062 336.085938 303.5 C 335.964844 303.839844 335.832031 304.203125 335.695312 304.585938 C 335.5625 304.96875 335.453125 305.390625 335.320312 305.824219 C 334.769531 307.546875 334.328125 309.667969 333.90625 312.023438 C 333.535156 314.390625 333.261719 317.011719 333.121094 319.773438 C 332.875 325.308594 333.1875 330.324219 333.523438 333.9375 C 333.683594 335.746094 333.847656 337.207031 333.96875 338.214844 C 334.019531 338.6875 334.0625 339.074219 334.097656 339.378906 C 334.121094 339.644531 334.128906 339.785156 334.117188 339.789062 C 334.105469 339.789062 334.074219 339.652344 334.023438 339.390625 C 333.972656 339.085938 333.910156 338.703125 333.828125 338.234375 C 333.667969 337.230469 333.464844 335.773438 333.269531 333.964844 C 332.867188 330.347656 332.511719 325.316406 332.761719 319.757812 C 332.902344 316.980469 333.1875 314.347656 333.578125 311.96875 C 334.023438 309.601562 334.492188 307.476562 335.078125 305.746094 C 335.21875 305.3125 335.335938 304.894531 335.480469 304.511719 C 335.625 304.132812 335.765625 303.769531 335.898438 303.429688 C 336.027344 303.097656 336.152344 302.78125 336.265625 302.492188 C 336.390625 302.207031 336.515625 301.953125 336.625 301.722656 C 336.835938 301.296875 337.003906 300.945312 337.140625 300.671875 C 337.261719 300.429688 337.332031 300.308594 337.34375 300.3125 Z M 337.34375 300.3125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 336.046875 286.839844 C 336.058594 286.84375 336.003906 287.035156 335.886719 287.390625 C 335.757812 287.777344 335.582031 288.292969 335.359375 288.9375 C 335.242188 289.277344 335.113281 289.652344 334.972656 290.054688 C 334.847656 290.472656 334.710938 290.921875 334.566406 291.402344 C 334.269531 292.363281 333.925781 293.460938 333.621094 294.691406 C 333.457031 295.308594 333.289062 295.949219 333.113281 296.617188 C 332.960938 297.292969 332.800781 297.996094 332.636719 298.726562 C 332.285156 300.175781 332.03125 301.75 331.703125 303.394531 C 331.144531 306.703125 330.652344 310.363281 330.3125 314.21875 C 329.996094 318.078125 329.855469 321.769531 329.804688 325.125 C 329.796875 328.484375 329.839844 331.507812 329.976562 334.042969 C 330.023438 335.3125 330.101562 336.457031 330.167969 337.464844 C 330.226562 338.472656 330.289062 339.339844 330.355469 340.046875 C 330.40625 340.730469 330.445312 341.273438 330.476562 341.675781 C 330.503906 342.050781 330.507812 342.246094 330.496094 342.25 C 330.484375 342.25 330.453125 342.058594 330.40625 341.6875 C 330.359375 341.28125 330.292969 340.738281 330.214844 340.058594 C 330.128906 339.351562 330.042969 338.488281 329.96875 337.480469 C 329.882812 336.472656 329.78125 335.328125 329.722656 334.054688 C 329.550781 331.519531 329.480469 328.488281 329.472656 325.125 C 329.503906 321.757812 329.636719 318.058594 329.957031 314.1875 C 330.296875 310.320312 330.796875 306.652344 331.375 303.335938 C 331.710938 301.6875 331.980469 300.109375 332.347656 298.65625 C 332.519531 297.929688 332.683594 297.226562 332.84375 296.550781 C 333.027344 295.878906 333.207031 295.238281 333.375 294.625 C 333.695312 293.394531 334.058594 292.300781 334.375 291.339844 C 334.53125 290.859375 334.675781 290.414062 334.808594 290 C 334.960938 289.597656 335.101562 289.226562 335.226562 288.890625 C 335.476562 288.253906 335.671875 287.742188 335.820312 287.363281 C 335.957031 287.015625 336.035156 286.835938 336.046875 286.839844 Z M 336.046875 286.839844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 322.859375 344.945312 C 322.855469 344.945312 322.84375 344.882812 322.832031 344.753906 C 322.820312 344.601562 322.804688 344.414062 322.78125 344.179688 C 322.746094 343.648438 322.699219 342.910156 322.632812 341.972656 C 322.511719 340.03125 322.339844 337.265625 322.125 333.859375 C 321.6875 327.011719 321.050781 317.546875 319.898438 307.140625 C 319.308594 301.9375 318.625 296.996094 317.914062 292.515625 C 317.539062 290.277344 317.195312 288.148438 316.808594 286.171875 C 316.453125 284.183594 316.066406 282.34375 315.714844 280.667969 C 315.382812 278.984375 315.011719 277.476562 314.710938 276.148438 C 314.417969 274.816406 314.136719 273.675781 313.898438 272.746094 C 313.675781 271.835938 313.5 271.117188 313.371094 270.601562 C 313.320312 270.371094 313.277344 270.1875 313.242188 270.039062 C 313.21875 269.914062 313.207031 269.847656 313.210938 269.84375 C 313.21875 269.84375 313.242188 269.90625 313.277344 270.03125 C 313.320312 270.175781 313.375 270.355469 313.441406 270.582031 C 313.585938 271.09375 313.78125 271.808594 314.035156 272.710938 C 314.292969 273.636719 314.597656 274.773438 314.90625 276.101562 C 315.226562 277.425781 315.613281 278.933594 315.964844 280.613281 C 316.332031 282.289062 316.730469 284.128906 317.101562 286.113281 C 317.503906 288.09375 317.855469 290.222656 318.242188 292.460938 C 318.972656 296.945312 319.667969 301.890625 320.257812 307.101562 C 321.410156 317.519531 322.003906 326.992188 322.378906 333.84375 C 322.566406 337.273438 322.695312 340.046875 322.773438 341.96875 C 322.808594 342.90625 322.835938 343.644531 322.855469 344.175781 C 322.859375 344.414062 322.863281 344.601562 322.867188 344.753906 C 322.867188 344.878906 322.867188 344.945312 322.859375 344.945312 Z M 322.859375 344.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 325.648438 275.601562 C 325.429688 273.238281 323.042969 271.460938 320.675781 271.433594 C 318.304688 271.410156 316.09375 272.832031 314.644531 274.707031 C 313.195312 276.582031 312.398438 278.871094 311.742188 281.152344 C 310.144531 286.710938 309.273438 292.550781 309.957031 298.296875 C 310.636719 304.039062 312.96875 309.695312 317.089844 313.753906 C 317.761719 314.414062 318.628906 315.074219 319.546875 314.875 C 320.050781 314.769531 320.464844 314.421875 320.84375 314.074219 C 328.941406 306.761719 333.617188 295.804688 333.296875 284.898438 C 333.234375 282.714844 332.945312 280.441406 331.738281 278.621094 C 330.527344 276.800781 327.707031 274.867188 325.648438 275.601562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 307.953125 256.699219 C 306.839844 258.710938 305.726562 260.726562 304.613281 262.742188 C 304.535156 262.882812 304.433594 263.042969 304.273438 263.054688 C 304.097656 263.070312 303.964844 262.902344 303.871094 262.757812 C 300.929688 258.242188 297.988281 253.726562 295.042969 249.210938 L 297.078125 248.058594 Z M 307.953125 256.699219 "
  }), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface68",
    mask: "url(#mask21)",
    fill: "#050505"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 325.855469 267.589844 C 315.820312 261.667969 305.785156 255.746094 295.75 249.828125 C 295.441406 249.644531 295.109375 249.429688 295.015625 249.085938 C 294.894531 248.640625 295.230469 248.210938 295.550781 247.878906 C 299.691406 243.609375 305.707031 241.132812 311.640625 241.558594 C 317.574219 241.988281 323.277344 245.414062 326.183594 250.605469 C 329.089844 255.796875 329.1875 262.664062 325.855469 267.589844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 300.085938 244.15625 C 300.085938 244.144531 300.222656 244.128906 300.480469 244.105469 C 300.742188 244.09375 301.125 244.046875 301.621094 244.054688 C 302.609375 244.027344 304.046875 244.09375 305.796875 244.386719 C 307.542969 244.671875 309.597656 245.234375 311.746094 246.191406 C 313.890625 247.144531 316.109375 248.523438 318.128906 250.335938 C 320.136719 252.167969 321.730469 254.238281 322.890625 256.277344 C 324.058594 258.316406 324.820312 260.304688 325.28125 262.015625 C 325.746094 263.730469 325.953125 265.152344 326.027344 266.140625 C 326.082031 266.632812 326.0625 266.757812 326.074219 267.019531 C 326.078125 267.277344 325.855469 267.671875 325.839844 267.675781 C 325.808594 267.675781 326.007812 267.128906 325.886719 266.15625 C 325.769531 265.179688 325.527344 263.773438 325.035156 262.085938 C 324.085938 258.734375 321.875 254.214844 317.886719 250.601562 C 313.898438 246.996094 309.179688 245.25 305.75 244.636719 C 304.023438 244.316406 302.601562 244.210938 301.617188 244.195312 C 300.636719 244.171875 300.089844 244.1875 300.085938 244.15625 Z M 300.085938 244.15625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 321.777344 255.332031 C 321.796875 255.375 321.214844 255.644531 320.257812 256.023438 C 319.296875 256.402344 317.957031 256.882812 316.457031 257.359375 C 314.957031 257.835938 313.585938 258.214844 312.582031 258.460938 C 311.582031 258.703125 310.953125 258.820312 310.941406 258.773438 C 310.929688 258.722656 311.53125 258.519531 312.515625 258.214844 C 313.625 257.867188 314.917969 257.460938 316.347656 257.015625 C 317.773438 256.554688 319.066406 256.140625 320.171875 255.78125 C 321.148438 255.464844 321.761719 255.28125 321.777344 255.332031 Z M 321.777344 255.332031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 317.039062 242.597656 C 317.136719 242.585938 317.347656 244.089844 317.394531 245.953125 C 317.441406 247.820312 317.304688 249.332031 317.207031 249.328125 C 317.105469 249.324219 317.082031 247.816406 317.035156 245.964844 C 316.988281 244.109375 316.9375 242.605469 317.039062 242.597656 Z M 317.039062 242.597656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 295.484375 249.488281 C 295.472656 249.445312 296.304688 249.140625 297.671875 248.71875 C 299.039062 248.296875 300.945312 247.765625 303.070312 247.253906 C 305.191406 246.742188 307.132812 246.347656 308.542969 246.101562 C 309.953125 245.855469 310.832031 245.742188 310.839844 245.792969 C 310.847656 245.839844 309.988281 246.039062 308.59375 246.351562 C 307.199219 246.664062 305.273438 247.09375 303.152344 247.601562 C 301.035156 248.113281 299.125 248.605469 297.742188 248.964844 C 296.359375 249.324219 295.5 249.539062 295.484375 249.488281 Z M 295.484375 249.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 313.15625 270.480469 C 310.566406 268.515625 307.828125 268.128906 304.582031 268.257812 C 301.332031 268.386719 298.171875 269.375 295.195312 270.679688 C 290.121094 272.902344 285.347656 276.179688 282.316406 280.816406 C 279.28125 285.457031 278.226562 291.597656 280.5 296.652344 C 280.726562 297.15625 281.019531 297.679688 281.527344 297.898438 C 282.0625 298.128906 282.671875 297.949219 283.226562 297.769531 C 289 295.886719 294.8125 293.984375 300.121094 291.035156 C 305.429688 288.085938 310.261719 283.984375 313.113281 278.621094 C 313.796875 277.332031 314.367188 275.953125 314.480469 274.5 C 314.589844 273.050781 314.191406 271.503906 313.15625 270.480469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 313.207031 269.871094 C 313.210938 269.882812 313.066406 269.941406 312.792969 270.039062 C 312.480469 270.144531 312.078125 270.285156 311.582031 270.457031 C 311.3125 270.542969 311.023438 270.640625 310.707031 270.746094 C 310.386719 270.863281 310.050781 271.003906 309.683594 271.144531 C 308.953125 271.441406 308.105469 271.734375 307.210938 272.167969 C 306.757812 272.375 306.285156 272.589844 305.796875 272.8125 C 305.304688 273.039062 304.8125 273.320312 304.296875 273.585938 C 303.25 274.097656 302.191406 274.753906 301.0625 275.421875 C 298.847656 276.820312 296.507812 278.503906 294.226562 280.492188 C 291.964844 282.5 289.996094 284.609375 288.324219 286.625 C 287.523438 287.660156 286.734375 288.628906 286.09375 289.597656 C 285.765625 290.078125 285.425781 290.53125 285.136719 290.988281 C 284.851562 291.449219 284.578125 291.890625 284.316406 292.3125 C 283.773438 293.140625 283.375 293.945312 282.988281 294.632812 C 282.800781 294.976562 282.613281 295.296875 282.460938 295.597656 C 282.316406 295.898438 282.183594 296.171875 282.058594 296.429688 C 281.828125 296.898438 281.640625 297.277344 281.492188 297.574219 C 281.359375 297.835938 281.285156 297.96875 281.273438 297.964844 C 281.261719 297.960938 281.316406 297.816406 281.425781 297.542969 C 281.558594 297.242188 281.726562 296.851562 281.933594 296.367188 C 282.046875 296.109375 282.171875 295.824219 282.308594 295.519531 C 282.453125 295.210938 282.628906 294.890625 282.808594 294.539062 C 283.179688 293.839844 283.566406 293.023438 284.097656 292.179688 C 284.355469 291.75 284.625 291.304688 284.902344 290.835938 C 285.1875 290.371094 285.523438 289.914062 285.847656 289.429688 C 286.484375 288.441406 287.265625 287.460938 288.070312 286.414062 C 289.734375 284.375 291.710938 282.242188 293.988281 280.21875 C 296.285156 278.21875 298.652344 276.53125 300.890625 275.136719 C 302.03125 274.472656 303.101562 273.824219 304.160156 273.316406 C 304.683594 273.058594 305.179688 272.78125 305.675781 272.5625 C 306.175781 272.34375 306.652344 272.132812 307.109375 271.933594 C 308.015625 271.511719 308.875 271.234375 309.613281 270.957031 C 309.984375 270.820312 310.328125 270.6875 310.652344 270.582031 C 310.972656 270.488281 311.269531 270.398438 311.539062 270.320312 C 312.046875 270.175781 312.453125 270.058594 312.773438 269.96875 C 313.054688 269.894531 313.203125 269.859375 313.207031 269.871094 Z M 313.207031 269.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 292.976562 280.824219 C 293.007812 280.917969 290.1875 281.828125 286.679688 282.851562 C 283.171875 283.878906 280.308594 284.632812 280.28125 284.535156 C 280.253906 284.4375 283.070312 283.53125 286.578125 282.503906 C 290.085938 281.480469 292.949219 280.726562 292.976562 280.824219 Z M 292.976562 280.824219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 292.71875 294.722656 C 292.671875 294.722656 292.613281 293.972656 292.582031 292.757812 C 292.546875 291.546875 292.542969 289.867188 292.59375 288.015625 C 292.644531 286.164062 292.746094 284.492188 292.84375 283.28125 C 292.945312 282.070312 293.042969 281.328125 293.09375 281.328125 C 293.144531 281.332031 293.136719 282.085938 293.101562 283.296875 C 293.058594 284.625 293.007812 286.238281 292.953125 288.027344 C 292.910156 289.8125 292.867188 291.429688 292.835938 292.757812 C 292.804688 293.96875 292.769531 294.722656 292.71875 294.722656 Z M 292.71875 294.722656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 304.625 288.65625 C 304.527344 288.664062 304.207031 285.253906 303.917969 281.046875 C 303.625 276.835938 303.472656 273.414062 303.570312 273.410156 C 303.667969 273.402344 303.988281 276.808594 304.277344 281.019531 C 304.570312 285.230469 304.722656 288.648438 304.625 288.65625 Z M 304.625 288.65625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 289.804688 273.078125 C 289.808594 273.027344 290.578125 273.007812 291.824219 273.015625 C 293.070312 273.027344 294.789062 273.0625 296.683594 273.125 C 298.582031 273.1875 300.296875 273.265625 301.542969 273.339844 C 302.785156 273.410156 303.554688 273.480469 303.550781 273.53125 C 303.550781 273.582031 302.78125 273.601562 301.535156 273.59375 C 300.292969 273.585938 298.570312 273.546875 296.671875 273.484375 C 294.773438 273.421875 293.054688 273.34375 291.8125 273.273438 C 290.570312 273.199219 289.800781 273.128906 289.804688 273.078125 Z M 289.804688 273.078125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 318.382812 314.542969 C 318.371094 314.542969 318.355469 314.40625 318.339844 314.140625 C 318.328125 313.839844 318.308594 313.457031 318.289062 312.984375 C 318.242188 311.976562 318.230469 310.519531 318.269531 308.71875 C 318.304688 306.917969 318.425781 304.777344 318.640625 302.40625 C 318.875 300.035156 319.214844 297.433594 319.703125 294.726562 C 320.199219 292.023438 320.800781 289.46875 321.414062 287.164062 C 322.046875 284.863281 322.691406 282.8125 323.292969 281.109375 C 323.890625 279.40625 324.414062 278.042969 324.8125 277.113281 C 325 276.679688 325.152344 276.328125 325.269531 276.046875 C 325.378906 275.804688 325.441406 275.679688 325.453125 275.683594 C 325.464844 275.6875 325.425781 275.820312 325.339844 276.074219 C 325.234375 276.359375 325.105469 276.71875 324.945312 277.164062 C 324.585938 278.105469 324.101562 279.480469 323.535156 281.191406 C 322.964844 282.894531 322.347656 284.949219 321.734375 287.246094 C 321.140625 289.546875 320.554688 292.09375 320.054688 294.789062 C 319.570312 297.488281 319.222656 300.074219 318.972656 302.4375 C 318.738281 304.800781 318.589844 306.933594 318.523438 308.726562 C 318.453125 310.523438 318.425781 311.976562 318.425781 312.980469 C 318.421875 313.453125 318.417969 313.835938 318.414062 314.140625 C 318.40625 314.40625 318.394531 314.542969 318.382812 314.542969 Z M 318.382812 314.542969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 319.972656 294.835938 C 320.003906 294.871094 319.550781 295.375 318.769531 296.152344 C 317.992188 296.929688 316.886719 297.972656 315.625 299.078125 C 314.363281 300.183594 313.183594 301.144531 312.3125 301.816406 C 311.4375 302.488281 310.878906 302.871094 310.847656 302.832031 C 310.816406 302.792969 311.320312 302.335938 312.148438 301.617188 C 313.074219 300.8125 314.171875 299.859375 315.386719 298.808594 C 316.589844 297.742188 317.679688 296.777344 318.597656 295.964844 C 319.417969 295.238281 319.933594 294.796875 319.972656 294.835938 Z M 319.972656 294.835938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 329.5 302.507812 C 329.457031 302.535156 328.980469 301.851562 328.222656 300.738281 C 327.398438 299.535156 326.375 298.046875 325.246094 296.394531 C 324.09375 294.761719 323.046875 293.285156 322.207031 292.097656 C 321.429688 291 320.953125 290.3125 320.992188 290.28125 C 321.03125 290.253906 321.578125 290.882812 322.414062 291.945312 C 323.25 293.003906 324.367188 294.5 325.542969 296.191406 C 326.71875 297.878906 327.730469 299.445312 328.433594 300.597656 C 329.140625 301.75 329.539062 302.484375 329.5 302.507812 Z M 329.5 302.507812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 324.507812 278.371094 C 324.5625 278.453125 321.398438 280.585938 317.4375 283.128906 C 313.480469 285.671875 310.226562 287.667969 310.175781 287.585938 C 310.121094 287.5 313.285156 285.371094 317.242188 282.824219 C 321.203125 280.28125 324.453125 278.285156 324.507812 278.371094 Z M 324.507812 278.371094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 333.433594 288.003906 C 333.363281 288.074219 331.21875 286.09375 328.644531 283.578125 C 326.070312 281.0625 324.039062 278.96875 324.109375 278.898438 C 324.179688 278.824219 326.324219 280.804688 328.898438 283.320312 C 331.472656 285.835938 333.503906 287.933594 333.433594 288.003906 Z M 333.433594 288.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 335.679688 287.808594 L 338.394531 287.585938 C 340.324219 287.425781 342.195312 286.855469 343.882812 285.90625 C 344.71875 285.4375 345.554688 284.976562 346.441406 284.621094 C 349.800781 283.269531 353.546875 283.511719 357.164062 283.332031 C 363.066406 283.035156 368.902344 281.542969 374.222656 278.96875 C 374.53125 278.820312 374.800781 278.59375 374.964844 278.292969 C 375.523438 277.277344 374.488281 276.371094 373.59375 275.824219 C 369.019531 273 364.359375 270.144531 359.167969 268.746094 C 353.972656 267.34375 348.082031 267.582031 343.652344 270.628906 C 338.453125 274.207031 336.558594 281.558594 335.679688 287.808594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 375.027344 277.960938 C 375.019531 277.972656 374.863281 277.898438 374.566406 277.746094 C 374.242188 277.578125 373.8125 277.351562 373.277344 277.074219 C 372.160156 276.484375 370.554688 275.617188 368.523438 274.644531 C 366.488281 273.679688 364.023438 272.59375 361.160156 271.804688 C 358.304688 271.011719 355.011719 270.597656 351.613281 271.03125 C 348.234375 271.476562 345.117188 272.792969 342.914062 274.769531 C 340.695312 276.738281 339.339844 279.113281 338.382812 281.132812 C 337.429688 283.167969 336.839844 284.902344 336.414062 286.085938 C 336.210938 286.65625 336.050781 287.109375 335.929688 287.457031 C 335.816406 287.769531 335.75 287.933594 335.738281 287.929688 C 335.726562 287.925781 335.769531 287.753906 335.859375 287.433594 C 335.964844 287.082031 336.105469 286.621094 336.277344 286.042969 C 336.667969 284.839844 337.21875 283.089844 338.152344 281.023438 C 339.085938 278.976562 340.433594 276.546875 342.695312 274.519531 C 344.9375 272.480469 348.125 271.125 351.566406 270.675781 C 355.019531 270.230469 358.367188 270.664062 361.246094 271.484375 C 364.136719 272.296875 366.605469 273.417969 368.632812 274.414062 C 370.65625 275.421875 372.25 276.324219 373.34375 276.949219 C 373.867188 277.253906 374.285156 277.496094 374.601562 277.683594 C 374.886719 277.855469 375.03125 277.949219 375.027344 277.960938 Z M 375.027344 277.960938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 368.5 281.46875 C 368.445312 281.550781 364.890625 279.25 360.5625 276.332031 C 356.234375 273.414062 352.773438 270.980469 352.828125 270.898438 C 352.882812 270.816406 356.4375 273.113281 360.765625 276.035156 C 365.09375 278.953125 368.558594 281.386719 368.5 281.46875 Z M 368.5 281.46875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 364.710938 270.710938 C 364.726562 270.792969 363.578125 271.058594 362.125 271.175781 C 360.667969 271.300781 359.484375 271.222656 359.484375 271.144531 C 359.484375 271.058594 360.65625 270.996094 362.09375 270.875 C 363.527344 270.761719 364.691406 270.628906 364.710938 270.710938 Z M 364.710938 270.710938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 349.152344 268.683594 C 349.238281 268.722656 348.71875 269.539062 347.988281 270.503906 C 347.257812 271.472656 346.597656 272.222656 346.511719 272.183594 C 346.425781 272.144531 346.945312 271.328125 347.675781 270.363281 C 348.40625 269.398438 349.066406 268.644531 349.152344 268.683594 Z M 349.152344 268.683594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 352.335938 283.5625 C 352.3125 283.601562 351.65625 283.257812 350.628906 282.632812 C 349.601562 282.011719 348.214844 281.097656 346.730469 280.023438 C 345.25 278.945312 343.941406 277.925781 343.003906 277.179688 C 342.0625 276.433594 341.496094 275.957031 341.527344 275.914062 C 341.554688 275.875 342.175781 276.28125 343.15625 276.976562 C 344.222656 277.753906 345.511719 278.691406 346.941406 279.730469 C 348.421875 280.800781 349.777344 281.742188 350.765625 282.421875 C 351.753906 283.09375 352.363281 283.515625 352.335938 283.5625 Z M 352.335938 283.5625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 339.679688 299.355469 C 337.085938 298.667969 333.996094 301.191406 333.464844 303.816406 C 332.929688 306.445312 333.914062 309.132812 335.070312 311.550781 C 337.621094 316.90625 341.144531 321.875 345.785156 325.574219 C 350.425781 329.273438 356.238281 331.636719 362.175781 331.605469 C 361.078125 326.519531 362.464844 321.199219 361.855469 316.03125 C 361.320312 311.519531 359.214844 307.207031 355.988281 304.011719 C 352.757812 300.8125 348.425781 298.753906 343.910156 298.265625 C 342.253906 298.085938 340.339844 297.828125 339.679688 299.355469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 362.171875 331.605469 C 362.167969 331.617188 362.042969 331.558594 361.804688 331.433594 C 361.570312 331.308594 361.234375 331.101562 360.835938 330.785156 C 360.023438 330.167969 359.089844 328.976562 358.277344 327.363281 C 357.863281 326.558594 357.402344 325.6875 356.949219 324.722656 C 356.511719 323.753906 356.046875 322.722656 355.554688 321.640625 C 355.0625 320.5625 354.515625 319.441406 353.839844 318.347656 C 353.167969 317.25 352.371094 316.179688 351.484375 315.140625 C 349.707031 313.054688 347.804688 311.253906 346.15625 309.527344 C 344.496094 307.8125 343.101562 306.160156 342.089844 304.65625 C 341.074219 303.15625 340.457031 301.808594 340.105469 300.863281 C 339.9375 300.382812 339.820312 300.011719 339.757812 299.75 C 339.695312 299.492188 339.664062 299.355469 339.675781 299.351562 C 339.710938 299.34375 339.859375 299.882812 340.238281 300.8125 C 340.625 301.734375 341.265625 303.042969 342.300781 304.507812 C 343.328125 305.980469 344.726562 307.601562 346.394531 309.296875 C 348.050781 311 349.964844 312.800781 351.757812 314.90625 C 352.652344 315.957031 353.464844 317.042969 354.140625 318.160156 C 354.824219 319.277344 355.367188 320.414062 355.855469 321.503906 C 356.335938 322.589844 356.792969 323.625 357.21875 324.597656 C 357.65625 325.558594 358.105469 326.4375 358.5 327.246094 C 359.28125 328.863281 360.152344 330.035156 360.925781 330.675781 C 361.683594 331.332031 362.195312 331.574219 362.171875 331.605469 Z M 362.171875 331.605469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 348.769531 327.378906 C 348.722656 327.367188 348.804688 326.699219 349.007812 325.632812 C 349.210938 324.566406 349.542969 323.101562 349.992188 321.503906 C 350.445312 319.90625 350.925781 318.484375 351.308594 317.46875 C 351.691406 316.453125 351.972656 315.839844 352.015625 315.855469 C 352.066406 315.875 351.871094 316.515625 351.550781 317.550781 C 351.230469 318.585938 350.789062 320.011719 350.339844 321.601562 C 349.894531 323.191406 349.523438 324.640625 349.257812 325.691406 C 348.992188 326.738281 348.824219 327.390625 348.769531 327.378906 Z M 348.769531 327.378906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 361.683594 314.886719 C 361.667969 314.933594 360.972656 314.757812 359.855469 314.464844 C 358.738281 314.171875 357.199219 313.773438 355.480469 313.386719 C 353.765625 313.003906 352.203125 312.703125 351.066406 312.488281 C 349.933594 312.273438 349.230469 312.132812 349.238281 312.082031 C 349.242188 312.035156 349.960938 312.085938 351.105469 312.234375 C 352.253906 312.386719 353.835938 312.648438 355.5625 313.035156 C 357.285156 313.425781 358.824219 313.867188 359.925781 314.222656 C 361.03125 314.578125 361.695312 314.839844 361.683594 314.886719 Z M 361.683594 314.886719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 339.152344 318.515625 C 339.105469 318.507812 339.207031 317.734375 339.433594 316.496094 C 339.660156 315.257812 340.023438 313.558594 340.507812 311.699219 C 340.996094 309.839844 341.507812 308.179688 341.914062 306.988281 C 342.320312 305.796875 342.613281 305.074219 342.65625 305.089844 C 342.707031 305.105469 342.5 305.855469 342.160156 307.0625 C 341.816406 308.273438 341.34375 309.9375 340.859375 311.789062 C 340.375 313.640625 339.976562 315.328125 339.683594 316.546875 C 339.394531 317.769531 339.203125 318.527344 339.152344 318.515625 Z M 339.152344 318.515625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 355.738281 304 C 355.726562 304.097656 352.492188 303.835938 348.511719 303.414062 C 344.53125 302.992188 341.3125 302.570312 341.324219 302.472656 C 341.332031 302.371094 344.566406 302.632812 348.546875 303.054688 C 352.527344 303.476562 355.746094 303.898438 355.738281 304 Z M 355.738281 304 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#88a5b5",
      fillOpacity: 1
    },
    d: "M 353.367188 343.238281 C 353.367188 343.335938 341.992188 343.417969 327.964844 343.417969 C 313.933594 343.417969 302.5625 343.335938 302.5625 343.238281 C 302.5625 343.136719 313.933594 343.058594 327.964844 343.058594 C 341.992188 343.058594 353.367188 343.136719 353.367188 343.238281 Z M 353.367188 343.238281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#88a5b5",
      fillOpacity: 1
    },
    d: "M 345.453125 357.875 C 345.453125 357.972656 337.789062 358.054688 328.339844 358.054688 C 318.886719 358.054688 311.222656 357.972656 311.222656 357.875 C 311.222656 357.773438 318.886719 357.695312 328.339844 357.695312 C 337.789062 357.691406 345.453125 357.773438 345.453125 357.875 Z M 345.453125 357.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#88a5b5",
      fillOpacity: 1
    },
    d: "M 345.15625 359.964844 C 345.15625 360.066406 337.625 360.144531 328.339844 360.144531 C 319.050781 360.144531 311.523438 360.066406 311.523438 359.964844 C 311.523438 359.867188 319.050781 359.785156 328.339844 359.785156 C 337.625 359.785156 345.15625 359.867188 345.15625 359.964844 Z M 345.15625 359.964844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#88a5b5",
      fillOpacity: 1
    },
    d: "M 345.753906 356.148438 C 345.753906 356.246094 337.824219 356.328125 328.050781 356.328125 C 318.269531 356.328125 310.34375 356.246094 310.34375 356.148438 C 310.34375 356.046875 318.269531 355.96875 328.050781 355.96875 C 337.824219 355.96875 345.753906 356.046875 345.753906 356.148438 Z M 345.753906 356.148438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 342.363281 47.898438 C 342.363281 48.015625 336.992188 48.078125 330.371094 48.042969 C 323.746094 48.007812 318.378906 47.886719 318.378906 47.773438 C 318.378906 47.65625 323.75 47.59375 330.371094 47.628906 C 336.992188 47.664062 342.363281 47.785156 342.363281 47.898438 Z M 342.363281 47.898438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 330.492188 59.828125 C 330.375 59.828125 330.230469 54.460938 330.164062 47.839844 C 330.09375 41.214844 330.132812 35.84375 330.25 35.84375 C 330.363281 35.84375 330.511719 41.210938 330.578125 47.832031 C 330.644531 54.457031 330.605469 59.828125 330.492188 59.828125 Z M 330.492188 59.828125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 355.011719 226.949219 C 354.957031 227.050781 351.664062 225.472656 347.648438 223.421875 C 343.636719 221.371094 340.425781 219.625 340.476562 219.523438 C 340.53125 219.421875 343.824219 221 347.839844 223.050781 C 351.851562 225.101562 355.0625 226.84375 355.011719 226.949219 Z M 355.011719 226.949219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 344.144531 230.558594 C 344.039062 230.507812 345.570312 227.1875 347.558594 223.144531 C 349.546875 219.097656 351.242188 215.863281 351.34375 215.914062 C 351.445312 215.964844 349.917969 219.28125 347.929688 223.328125 C 345.941406 227.371094 344.246094 230.609375 344.144531 230.558594 Z M 344.144531 230.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 67.835938 170.617188 C 67.878906 170.722656 64.050781 172.351562 59.289062 174.25 C 54.523438 176.148438 50.625 177.601562 50.582031 177.496094 C 50.539062 177.390625 54.367188 175.761719 59.132812 173.863281 C 63.898438 171.964844 67.796875 170.511719 67.835938 170.617188 Z M 67.835938 170.617188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 59.007812 165.417969 C 58.972656 165.433594 58.871094 165.183594 58.582031 164.816406 C 58.296875 164.457031 57.773438 163.980469 56.976562 163.777344 C 56.199219 163.5625 55.128906 163.703125 54.335938 164.429688 C 53.539062 165.121094 53.136719 166.425781 53.605469 167.570312 C 54.054688 168.722656 55.242188 169.390625 56.296875 169.347656 C 57.371094 169.328125 58.246094 168.695312 58.664062 168.003906 C 59.101562 167.308594 59.152344 166.601562 59.109375 166.144531 C 59.070312 165.679688 58.972656 165.429688 59.007812 165.417969 C 59.023438 165.410156 59.175781 165.640625 59.273438 166.125 C 59.367188 166.597656 59.363281 167.367188 58.914062 168.15625 C 58.492188 168.9375 57.53125 169.6875 56.308594 169.730469 C 55.113281 169.808594 53.734375 169.050781 53.21875 167.726562 C 52.679688 166.40625 53.160156 164.910156 54.082031 164.140625 C 55 163.335938 56.210938 163.21875 57.054688 163.492188 C 57.921875 163.757812 58.453125 164.3125 58.714844 164.722656 C 58.976562 165.140625 59.027344 165.410156 59.007812 165.417969 Z M 59.007812 165.417969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 65.007812 180.464844 C 64.972656 180.480469 64.871094 180.230469 64.582031 179.863281 C 64.296875 179.503906 63.773438 179.027344 62.976562 178.824219 C 62.199219 178.609375 61.128906 178.75 60.335938 179.476562 C 59.539062 180.167969 59.136719 181.472656 59.605469 182.617188 C 60.054688 183.769531 61.242188 184.4375 62.296875 184.394531 C 63.371094 184.375 64.246094 183.742188 64.660156 183.050781 C 65.097656 182.355469 65.152344 181.648438 65.109375 181.191406 C 65.066406 180.730469 64.96875 180.476562 65.007812 180.464844 C 65.023438 180.457031 65.175781 180.6875 65.269531 181.171875 C 65.363281 181.644531 65.363281 182.414062 64.914062 183.203125 C 64.488281 183.984375 63.53125 184.734375 62.308594 184.777344 C 61.109375 184.855469 59.730469 184.097656 59.21875 182.769531 C 58.679688 181.453125 59.160156 179.957031 60.082031 179.1875 C 61 178.378906 62.210938 178.265625 63.054688 178.539062 C 63.921875 178.804688 64.453125 179.359375 64.710938 179.769531 C 64.976562 180.1875 65.023438 180.460938 65.007812 180.464844 Z M 65.007812 180.464844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,19.607843%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 112.570312 87.457031 C 112.570312 87.457031 112.660156 87.671875 112.8125 88.089844 C 112.96875 88.519531 113.1875 89.136719 113.476562 89.9375 C 114.050781 91.574219 114.894531 93.960938 115.976562 97.035156 L 116.027344 97.183594 L 115.871094 97.164062 C 113.039062 96.777344 109.558594 96.304688 105.570312 95.761719 L 105.667969 95.734375 C 102.523438 98.207031 98.320312 100.34375 93.339844 101.117188 C 92.101562 101.320312 90.820312 101.433594 89.507812 101.445312 C 88.851562 101.464844 88.191406 101.394531 87.523438 101.375 C 87.1875 101.359375 86.855469 101.339844 86.515625 101.324219 C 86.179688 101.296875 85.84375 101.230469 85.507812 101.183594 C 82.796875 100.867188 80.050781 100.019531 77.425781 98.746094 C 74.796875 97.476562 72.285156 95.734375 70.089844 93.550781 C 67.90625 91.355469 66.050781 88.714844 64.699219 85.765625 C 61.980469 79.882812 61.414062 72.675781 63.621094 66.0625 C 65.523438 60.15625 69.585938 55.253906 74.421875 52.039062 C 76.839844 50.410156 79.527344 49.308594 82.21875 48.574219 L 83.234375 48.3125 L 83.742188 48.1875 L 84.253906 48.105469 C 84.941406 48.003906 85.621094 47.898438 86.300781 47.796875 C 86.980469 47.738281 87.664062 47.722656 88.339844 47.683594 C 89.015625 47.625 89.6875 47.664062 90.355469 47.703125 C 91.023438 47.757812 91.691406 47.730469 92.339844 47.851562 C 92.996094 47.953125 93.644531 48.050781 94.289062 48.152344 C 94.929688 48.253906 95.546875 48.457031 96.171875 48.605469 L 97.105469 48.847656 C 97.40625 48.945312 97.703125 49.0625 98 49.171875 C 100.417969 49.949219 102.570312 51.195312 104.539062 52.511719 C 108.410156 55.277344 111.332031 58.777344 113.105469 62.40625 C 114.921875 66.019531 115.726562 69.660156 115.914062 72.847656 C 116.164062 76.050781 115.722656 78.820312 115.183594 81 C 114.628906 83.183594 113.929688 84.800781 113.421875 85.867188 C 113.160156 86.402344 112.953125 86.800781 112.804688 87.058594 C 112.65625 87.320312 112.570312 87.457031 112.570312 87.457031 C 112.570312 87.457031 112.628906 87.320312 112.765625 87.046875 C 112.90625 86.773438 113.101562 86.367188 113.347656 85.832031 C 113.832031 84.757812 114.5 83.136719 115.027344 80.957031 C 115.539062 78.785156 115.953125 76.035156 115.683594 72.863281 C 115.476562 69.703125 114.660156 66.105469 112.84375 62.539062 C 111.074219 58.957031 108.171875 55.511719 104.34375 52.792969 C 102.394531 51.5 100.269531 50.277344 97.882812 49.515625 C 97.589844 49.410156 97.296875 49.292969 96.996094 49.199219 L 96.078125 48.964844 C 95.460938 48.820312 94.851562 48.617188 94.21875 48.519531 C 93.582031 48.421875 92.941406 48.324219 92.300781 48.226562 C 91.660156 48.109375 90.996094 48.140625 90.339844 48.085938 C 89.683594 48.046875 89.019531 48.007812 88.351562 48.070312 C 87.6875 48.109375 87.015625 48.128906 86.34375 48.183594 C 85.675781 48.289062 85.003906 48.390625 84.328125 48.492188 L 83.824219 48.570312 L 82.324219 48.957031 C 79.671875 49.683594 77.027344 50.769531 74.644531 52.378906 C 69.886719 55.546875 65.890625 60.378906 64.019531 66.191406 C 61.847656 72.703125 62.402344 79.800781 65.074219 85.59375 C 66.398438 88.5 68.222656 91.105469 70.367188 93.273438 C 72.53125 95.429688 75.003906 97.148438 77.589844 98.40625 C 80.175781 99.667969 82.882812 100.511719 85.558594 100.832031 C 85.890625 100.875 86.21875 100.941406 86.550781 100.972656 C 86.886719 100.992188 87.214844 101.007812 87.546875 101.023438 C 88.207031 101.046875 88.859375 101.117188 89.503906 101.101562 C 90.800781 101.09375 92.066406 100.984375 93.292969 100.792969 C 98.210938 100.042969 102.378906 97.953125 105.507812 95.523438 L 105.550781 95.492188 L 105.605469 95.5 C 109.59375 96.070312 113.070312 96.566406 115.898438 96.972656 L 115.796875 97.097656 C 114.746094 93.996094 113.933594 91.589844 113.375 89.9375 C 113.109375 89.132812 112.902344 88.515625 112.761719 88.085938 C 112.625 87.667969 112.570312 87.457031 112.570312 87.457031 Z M 112.570312 87.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 90.53125 68.335938 C 90.890625 68.507812 91.136719 68.875 91.136719 69.300781 L 91.136719 74.628906 C 91.136719 74.964844 90.980469 75.28125 90.710938 75.480469 C 90.445312 75.683594 90.097656 75.75 89.777344 75.660156 C 88.929688 75.421875 87.980469 75.566406 87.167969 76.058594 C 86.421875 76.511719 85.902344 77.203125 85.746094 77.960938 C 85.589844 78.710938 85.789062 79.558594 86.292969 80.289062 C 86.828125 81.066406 87.648438 81.609375 88.488281 81.742188 C 90.207031 82.015625 92.125 80.777344 92.679688 79.035156 C 92.859375 78.46875 93.460938 78.160156 94.023438 78.339844 C 94.597656 78.523438 94.898438 79.121094 94.71875 79.683594 C 93.847656 82.421875 90.902344 84.292969 88.152344 83.859375 C 86.726562 83.632812 85.40625 82.773438 84.53125 81.503906 C 83.699219 80.296875 83.378906 78.847656 83.652344 77.523438 C 83.929688 76.191406 84.804688 74.992188 86.058594 74.230469 C 86.964844 73.679688 87.988281 73.402344 88.996094 73.410156 L 88.996094 69.300781 C 88.996094 68.710938 89.476562 68.234375 90.066406 68.234375 C 90.234375 68.230469 90.390625 68.269531 90.53125 68.335938 Z M 90.53125 68.335938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1c427a",
      fillOpacity: 1
    },
    d: "M 89.058594 66.097656 C 89.042969 65.613281 89.425781 65.210938 89.910156 65.199219 C 90.394531 65.1875 90.792969 65.566406 90.804688 66.050781 C 90.820312 66.535156 90.4375 66.9375 89.953125 66.949219 C 89.472656 66.960938 89.070312 66.578125 89.058594 66.097656 Z M 89.058594 66.097656 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.d7466282e9983838a368c1c4e79161ae.svg";
export { ForwardRef as ReactComponent };